// Auto-generated from client Salsify data sheets + client price sheet (MattressTown_2026_Mattress_Pricing.xlsx).
// Real per-size prices; Set / Low-Profile-Set = mattress price + client foundation upcharge. compareAt = ~1.3x MSRP display.
export const CATALOG_2026 = [
 {
  "slug": "beautyrest-world-class-level-three-extra-firm-mattress",
  "name": "Beautyrest World Class Level Three Extra Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1299,
  "compareAt": 1699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1299,
    "compareAt": 1699
   },
   "Twin XL": {
    "price": 1299,
    "compareAt": 1699
   },
   "Full": {
    "price": 1399,
    "compareAt": 1799
   },
   "Queen": {
    "price": 1499,
    "compareAt": 1949
   },
   "King": {
    "price": 1999,
    "compareAt": 2599
   },
   "California King": {
    "price": 1999,
    "compareAt": 2599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
   "https://images.salsify.com/image/upload/s--0Q5MypYy--/wenmw8bjomlwxc2nbr8s.jpg",
   "https://images.salsify.com/image/upload/s--K2u0Tr8o--/pfibnedjzald37xrjzdg.jpg",
   "https://images.salsify.com/image/upload/s--kNdyH3Cn--/y6shd3gairtd5thicywq.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-extra-firm-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Extra Firm Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "20.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
   "https://images.salsify.com/image/upload/s--0Q5MypYy--/wenmw8bjomlwxc2nbr8s.jpg",
   "https://images.salsify.com/image/upload/s--K2u0Tr8o--/pfibnedjzald37xrjzdg.jpg",
   "https://images.salsify.com/image/upload/s--kNdyH3Cn--/y6shd3gairtd5thicywq.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-extra-firm-mattress-set",
  "name": "Beautyrest World Class Level Three Extra Firm Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5p4FeRyF--/vqlcckfp6gnkgdzgobwd.jpg",
   "https://images.salsify.com/image/upload/s--0Q5MypYy--/wenmw8bjomlwxc2nbr8s.jpg",
   "https://images.salsify.com/image/upload/s--K2u0Tr8o--/pfibnedjzald37xrjzdg.jpg",
   "https://images.salsify.com/image/upload/s--kNdyH3Cn--/y6shd3gairtd5thicywq.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-firm-mattress",
  "name": "Beautyrest World Class Level Three Medium Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1299,
  "compareAt": 1699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "14.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1299,
    "compareAt": 1699
   },
   "Twin XL": {
    "price": 1299,
    "compareAt": 1699
   },
   "Full": {
    "price": 1399,
    "compareAt": 1799
   },
   "Queen": {
    "price": 1499,
    "compareAt": 1949
   },
   "King": {
    "price": 1999,
    "compareAt": 2599
   },
   "California King": {
    "price": 1999,
    "compareAt": 2599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
   "https://images.salsify.com/image/upload/s--URn-775g--/vpk5qudeafr4ldydjv80.jpg",
   "https://images.salsify.com/image/upload/s--8zfZIbB2--/rnxdz1g5pvc3ukiqpgxp.jpg",
   "https://images.salsify.com/image/upload/s--1ie37tmC--/b2vcw61nxze7naytitw0.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-firm-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Medium Firm Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "20.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
   "https://images.salsify.com/image/upload/s--URn-775g--/vpk5qudeafr4ldydjv80.jpg",
   "https://images.salsify.com/image/upload/s--8zfZIbB2--/rnxdz1g5pvc3ukiqpgxp.jpg",
   "https://images.salsify.com/image/upload/s--1ie37tmC--/b2vcw61nxze7naytitw0.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-firm-mattress-set",
  "name": "Beautyrest World Class Level Three Medium Firm Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "23.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Dl8un1Ie--/g8at3i7sx5f6ugtcjdzb.jpg",
   "https://images.salsify.com/image/upload/s--URn-775g--/vpk5qudeafr4ldydjv80.jpg",
   "https://images.salsify.com/image/upload/s--8zfZIbB2--/rnxdz1g5pvc3ukiqpgxp.jpg",
   "https://images.salsify.com/image/upload/s--1ie37tmC--/b2vcw61nxze7naytitw0.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-mattress",
  "name": "Beautyrest World Class Level Three Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1299,
  "compareAt": 1699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "14.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1299,
    "compareAt": 1699
   },
   "Twin XL": {
    "price": 1299,
    "compareAt": 1699
   },
   "Full": {
    "price": 1399,
    "compareAt": 1799
   },
   "Queen": {
    "price": 1499,
    "compareAt": 1949
   },
   "King": {
    "price": 1999,
    "compareAt": 2599
   },
   "California King": {
    "price": 1999,
    "compareAt": 2599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
   "https://images.salsify.com/image/upload/s--sWYAEeE5--/ennkvf25ov5mculdqdbc.jpg",
   "https://images.salsify.com/image/upload/s--e5cr5VOL--/mthvys2z4u57w1eelug5.jpg",
   "https://images.salsify.com/image/upload/s--x_F12CmY--/bfaso4r3ibzoajhykobg.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Plush Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "20.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
   "https://images.salsify.com/image/upload/s--sWYAEeE5--/ennkvf25ov5mculdqdbc.jpg",
   "https://images.salsify.com/image/upload/s--e5cr5VOL--/mthvys2z4u57w1eelug5.jpg",
   "https://images.salsify.com/image/upload/s--x_F12CmY--/bfaso4r3ibzoajhykobg.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-mattress-set",
  "name": "Beautyrest World Class Level Three Plush Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1469,
  "compareAt": 1899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "23.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1469,
    "compareAt": 1899
   },
   "Twin XL": {
    "price": 1469,
    "compareAt": 1899
   },
   "Full": {
    "price": 1619,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2339,
    "compareAt": 3049
   },
   "California King": {
    "price": 2339,
    "compareAt": 3049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--JLE6uyVU--/bnzx2wjlg6ybo72jrqdx.jpg",
   "https://images.salsify.com/image/upload/s--sWYAEeE5--/ennkvf25ov5mculdqdbc.jpg",
   "https://images.salsify.com/image/upload/s--e5cr5VOL--/mthvys2z4u57w1eelug5.jpg",
   "https://images.salsify.com/image/upload/s--x_F12CmY--/bfaso4r3ibzoajhykobg.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-pillow-top-mattress",
  "name": "Beautyrest World Class Level Three Medium Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1499,
    "compareAt": 1949
   },
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Full": {
    "price": 1599,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2199,
    "compareAt": 2849
   },
   "California King": {
    "price": 2199,
    "compareAt": 2849
   }
  },
  "image": "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
   "https://images.salsify.com/image/upload/s--HO40iUbw--/ongm05bk3fxmucfvhz39.jpg",
   "https://images.salsify.com/image/upload/s--ea4SrayX--/hn9gucguvd2wvvkgvmzh.jpg",
   "https://images.salsify.com/image/upload/s--b8UljZ_q--/fmyzgkfydecyx4grwqem.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Medium Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1669,
    "compareAt": 2149
   },
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Full": {
    "price": 1819,
    "compareAt": 2349
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2539,
    "compareAt": 3299
   },
   "California King": {
    "price": 2539,
    "compareAt": 3299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
   "https://images.salsify.com/image/upload/s--HO40iUbw--/ongm05bk3fxmucfvhz39.jpg",
   "https://images.salsify.com/image/upload/s--ea4SrayX--/hn9gucguvd2wvvkgvmzh.jpg",
   "https://images.salsify.com/image/upload/s--b8UljZ_q--/fmyzgkfydecyx4grwqem.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-medium-pillow-top-mattress-set",
  "name": "Beautyrest World Class Level Three Medium Pillow Top Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1669,
    "compareAt": 2149
   },
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Full": {
    "price": 1819,
    "compareAt": 2349
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2539,
    "compareAt": 3299
   },
   "California King": {
    "price": 2539,
    "compareAt": 3299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--o2Sr3chw--/m3bmxaqycgaaortpinf4.jpg",
   "https://images.salsify.com/image/upload/s--HO40iUbw--/ongm05bk3fxmucfvhz39.jpg",
   "https://images.salsify.com/image/upload/s--ea4SrayX--/hn9gucguvd2wvvkgvmzh.jpg",
   "https://images.salsify.com/image/upload/s--b8UljZ_q--/fmyzgkfydecyx4grwqem.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-pillow-top-mattress",
  "name": "Beautyrest World Class Level Three Plush Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1499,
    "compareAt": 1949
   },
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Full": {
    "price": 1599,
    "compareAt": 2099
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2199,
    "compareAt": 2849
   },
   "California King": {
    "price": 2199,
    "compareAt": 2849
   }
  },
  "image": "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
   "https://images.salsify.com/image/upload/s--zQt39tra--/snzuxdh3ekv0myoyy7zx.jpg",
   "https://images.salsify.com/image/upload/s--nUO-ilzC--/ewdv9itt2cfucoqfko5m.jpg",
   "https://images.salsify.com/image/upload/s--ZgadQUSQ--/f1on6xuiurr8somxhfrm.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Plush Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1669,
    "compareAt": 2149
   },
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Full": {
    "price": 1819,
    "compareAt": 2349
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2539,
    "compareAt": 3299
   },
   "California King": {
    "price": 2539,
    "compareAt": 3299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
   "https://images.salsify.com/image/upload/s--zQt39tra--/snzuxdh3ekv0myoyy7zx.jpg",
   "https://images.salsify.com/image/upload/s--nUO-ilzC--/ewdv9itt2cfucoqfko5m.jpg",
   "https://images.salsify.com/image/upload/s--ZgadQUSQ--/f1on6xuiurr8somxhfrm.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-plush-pillow-top-mattress-set",
  "name": "Beautyrest World Class Level Three Plush Pillow Top Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1669,
    "compareAt": 2149
   },
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Full": {
    "price": 1819,
    "compareAt": 2349
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2539,
    "compareAt": 3299
   },
   "California King": {
    "price": 2539,
    "compareAt": 3299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--RZkwCusq--/dueyzc41qvajwmgpjfmw.jpg",
   "https://images.salsify.com/image/upload/s--zQt39tra--/snzuxdh3ekv0myoyy7zx.jpg",
   "https://images.salsify.com/image/upload/s--nUO-ilzC--/ewdv9itt2cfucoqfko5m.jpg",
   "https://images.salsify.com/image/upload/s--ZgadQUSQ--/f1on6xuiurr8somxhfrm.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-medium-mattress",
  "name": "Beautyrest World Class Level Four Medium Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1599,
    "compareAt": 2099
   },
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1699,
    "compareAt": 2199
   },
   "Queen": {
    "price": 1799,
    "compareAt": 2349
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
   "https://images.salsify.com/image/upload/s--1YGc8uj1--/vjlalykmr3wps2pldsbz.jpg",
   "https://images.salsify.com/image/upload/s--37S9xwIu--/y5zlptc26qwy6iyrgaop.jpg",
   "https://images.salsify.com/image/upload/s--FIcEEk0E--/xueep25j6pdahajlqyo2.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-medium-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Medium Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
   "https://images.salsify.com/image/upload/s--1YGc8uj1--/vjlalykmr3wps2pldsbz.jpg",
   "https://images.salsify.com/image/upload/s--37S9xwIu--/y5zlptc26qwy6iyrgaop.jpg",
   "https://images.salsify.com/image/upload/s--FIcEEk0E--/xueep25j6pdahajlqyo2.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-medium-mattress-set",
  "name": "Beautyrest World Class Level Four Medium Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--9YnBWEoi--/tfihz2ag4grivvawjdkv.jpg",
   "https://images.salsify.com/image/upload/s--1YGc8uj1--/vjlalykmr3wps2pldsbz.jpg",
   "https://images.salsify.com/image/upload/s--37S9xwIu--/y5zlptc26qwy6iyrgaop.jpg",
   "https://images.salsify.com/image/upload/s--FIcEEk0E--/xueep25j6pdahajlqyo2.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-mattress",
  "name": "Beautyrest World Class Level Four Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1599,
    "compareAt": 2099
   },
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1699,
    "compareAt": 2199
   },
   "Queen": {
    "price": 1799,
    "compareAt": 2349
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
   "https://images.salsify.com/image/upload/s--3XWiht_L--/tq27991gz3895yjrr9sc.jpg",
   "https://images.salsify.com/image/upload/s--0QRCAKh2--/d5umpxriznk9uyydddzz.jpg",
   "https://images.salsify.com/image/upload/s---UrsNKUV--/ur7evuorev297ustdwyh.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Plush Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
   "https://images.salsify.com/image/upload/s--3XWiht_L--/tq27991gz3895yjrr9sc.jpg",
   "https://images.salsify.com/image/upload/s--0QRCAKh2--/d5umpxriznk9uyydddzz.jpg",
   "https://images.salsify.com/image/upload/s---UrsNKUV--/ur7evuorev297ustdwyh.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-mattress-set",
  "name": "Beautyrest World Class Level Four Plush Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--jtTz8ZY8--/c3jscyjwnwy9ydxkdvmg.jpg",
   "https://images.salsify.com/image/upload/s--3XWiht_L--/tq27991gz3895yjrr9sc.jpg",
   "https://images.salsify.com/image/upload/s--0QRCAKh2--/d5umpxriznk9uyydddzz.jpg",
   "https://images.salsify.com/image/upload/s---UrsNKUV--/ur7evuorev297ustdwyh.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-firm-pillow-top-mattress",
  "name": "Beautyrest World Class Level Four Firm Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "16.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1799,
    "compareAt": 2349
   },
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1899,
    "compareAt": 2449
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
   "https://images.salsify.com/image/upload/s--paUxLg3C--/mlcgcqduytsulchvzagc.jpg",
   "https://images.salsify.com/image/upload/s--y87EIBDk--/jsvyn9msrrvnnql1agbf.jpg",
   "https://images.salsify.com/image/upload/s--dD--ihVc--/lgcweshywwas1cd7tkrc.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-firm-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Firm Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1969,
    "compareAt": 2549
   },
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2119,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
   "https://images.salsify.com/image/upload/s--paUxLg3C--/mlcgcqduytsulchvzagc.jpg",
   "https://images.salsify.com/image/upload/s--y87EIBDk--/jsvyn9msrrvnnql1agbf.jpg",
   "https://images.salsify.com/image/upload/s--dD--ihVc--/lgcweshywwas1cd7tkrc.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-firm-pillow-top-mattress-set",
  "name": "Beautyrest World Class Level Four Firm Pillow Top Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "25.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1969,
    "compareAt": 2549
   },
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2119,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Yc_Qn2R2--/pq516qedibrf2fkapvyc.jpg",
   "https://images.salsify.com/image/upload/s--paUxLg3C--/mlcgcqduytsulchvzagc.jpg",
   "https://images.salsify.com/image/upload/s--y87EIBDk--/jsvyn9msrrvnnql1agbf.jpg",
   "https://images.salsify.com/image/upload/s--dD--ihVc--/lgcweshywwas1cd7tkrc.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-pillow-top-mattress",
  "name": "Beautyrest World Class Level Four Plush Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1799,
    "compareAt": 2349
   },
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1899,
    "compareAt": 2449
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
   "https://images.salsify.com/image/upload/s--PDDEKNfr--/pncb1jihrdbv0wxbt1ik.jpg",
   "https://images.salsify.com/image/upload/s--x4eUUH7E--/paymdi9vwchqv74gxt54.jpg",
   "https://images.salsify.com/image/upload/s--mewae0_z--/nflhvaaqjw7dxc2nntph.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Plush Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1969,
    "compareAt": 2549
   },
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2119,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
   "https://images.salsify.com/image/upload/s--PDDEKNfr--/pncb1jihrdbv0wxbt1ik.jpg",
   "https://images.salsify.com/image/upload/s--x4eUUH7E--/paymdi9vwchqv74gxt54.jpg",
   "https://images.salsify.com/image/upload/s--mewae0_z--/nflhvaaqjw7dxc2nntph.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-plush-pillow-top-mattress-set",
  "name": "Beautyrest World Class Level Four Plush Pillow Top Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1969,
    "compareAt": 2549
   },
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2119,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TiunSulL--/lo6eedifuvbd1dae83am.jpg",
   "https://images.salsify.com/image/upload/s--PDDEKNfr--/pncb1jihrdbv0wxbt1ik.jpg",
   "https://images.salsify.com/image/upload/s--x4eUUH7E--/paymdi9vwchqv74gxt54.jpg",
   "https://images.salsify.com/image/upload/s--mewae0_z--/nflhvaaqjw7dxc2nntph.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-firm-mattress",
  "name": "Beautyrest World Class Level Three Hybrid Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1599,
    "compareAt": 2099
   },
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1699,
    "compareAt": 2199
   },
   "Queen": {
    "price": 1799,
    "compareAt": 2349
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
   "https://images.salsify.com/image/upload/s--la0qQQt6--/hpuauwq16ot07vk4v0yn.jpg",
   "https://images.salsify.com/image/upload/s--r7t1bt0y--/hivstoerevkccuwautpg.jpg",
   "https://images.salsify.com/image/upload/s--Eqbdavcg--/tn4kwjh0l51zhrlagy7x.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-firm-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Hybrid Firm Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
   "https://images.salsify.com/image/upload/s--la0qQQt6--/hpuauwq16ot07vk4v0yn.jpg",
   "https://images.salsify.com/image/upload/s--r7t1bt0y--/hivstoerevkccuwautpg.jpg",
   "https://images.salsify.com/image/upload/s--Eqbdavcg--/tn4kwjh0l51zhrlagy7x.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-firm-mattress-set",
  "name": "Beautyrest World Class Level Three Hybrid Firm Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qpoya2fq--/r9lhdxgjkcl70flmsszx.jpg",
   "https://images.salsify.com/image/upload/s--la0qQQt6--/hpuauwq16ot07vk4v0yn.jpg",
   "https://images.salsify.com/image/upload/s--r7t1bt0y--/hivstoerevkccuwautpg.jpg",
   "https://images.salsify.com/image/upload/s--Eqbdavcg--/tn4kwjh0l51zhrlagy7x.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-medium-mattress",
  "name": "Beautyrest World Class Level Three Hybrid Medium Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1599,
    "compareAt": 2099
   },
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1699,
    "compareAt": 2199
   },
   "Queen": {
    "price": 1799,
    "compareAt": 2349
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
   "https://images.salsify.com/image/upload/s--JQrk47pO--/yhslmwzfqmbe3aus4yi4.jpg",
   "https://images.salsify.com/image/upload/s--6L1XMFoi--/e7oz3bmjexoydoja6noa.jpg",
   "https://images.salsify.com/image/upload/s--UNcytjSw--/rpnl3vcpl3dfcyhmfv0l.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-medium-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Hybrid Medium Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
   "https://images.salsify.com/image/upload/s--JQrk47pO--/yhslmwzfqmbe3aus4yi4.jpg",
   "https://images.salsify.com/image/upload/s--6L1XMFoi--/e7oz3bmjexoydoja6noa.jpg",
   "https://images.salsify.com/image/upload/s--UNcytjSw--/rpnl3vcpl3dfcyhmfv0l.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-medium-mattress-set",
  "name": "Beautyrest World Class Level Three Hybrid Medium Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s---ijZi6Du--/zj2hj3avcohyadjispzn.jpg",
   "https://images.salsify.com/image/upload/s--JQrk47pO--/yhslmwzfqmbe3aus4yi4.jpg",
   "https://images.salsify.com/image/upload/s--6L1XMFoi--/e7oz3bmjexoydoja6noa.jpg",
   "https://images.salsify.com/image/upload/s--UNcytjSw--/rpnl3vcpl3dfcyhmfv0l.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-plush-mattress",
  "name": "Beautyrest World Class Level Three Hybrid Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1599,
    "compareAt": 2099
   },
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1699,
    "compareAt": 2199
   },
   "Queen": {
    "price": 1799,
    "compareAt": 2349
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
   "https://images.salsify.com/image/upload/s--0RtH5ODG--/yjdvnckyncgfid8chp2y.jpg",
   "https://images.salsify.com/image/upload/s--Ok1SYwgO--/x6zr4mrcu7v36exzyd76.jpg",
   "https://images.salsify.com/image/upload/s--lAk1DLv_--/cn40fatkqkeaq9tjnf3y.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-plush-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Three Hybrid Plush Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
   "https://images.salsify.com/image/upload/s--0RtH5ODG--/yjdvnckyncgfid8chp2y.jpg",
   "https://images.salsify.com/image/upload/s--Ok1SYwgO--/x6zr4mrcu7v36exzyd76.jpg",
   "https://images.salsify.com/image/upload/s--lAk1DLv_--/cn40fatkqkeaq9tjnf3y.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-three-hybrid-plush-mattress-set",
  "name": "Beautyrest World Class Level Three Hybrid Plush Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1769,
    "compareAt": 2299
   },
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1919,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2019,
    "compareAt": 2599
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ouySdocG--/uj5as1zpgwtrxl7qvpra.jpg",
   "https://images.salsify.com/image/upload/s--0RtH5ODG--/yjdvnckyncgfid8chp2y.jpg",
   "https://images.salsify.com/image/upload/s--Ok1SYwgO--/x6zr4mrcu7v36exzyd76.jpg",
   "https://images.salsify.com/image/upload/s--lAk1DLv_--/cn40fatkqkeaq9tjnf3y.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-firm-mattress",
  "name": "Beautyrest World Class Level Four Hybrid Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1899,
    "compareAt": 2449
   },
   "Twin XL": {
    "price": 1899,
    "compareAt": 2449
   },
   "Full": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2599,
    "compareAt": 3399
   },
   "California King": {
    "price": 2599,
    "compareAt": 3399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
   "https://images.salsify.com/image/upload/s--jTEMl41w--/wrukyxaq5o8212xanzjn.jpg",
   "https://images.salsify.com/image/upload/s--80fhAKqV--/fkqix5ay1g5j10tcnf1g.jpg",
   "https://images.salsify.com/image/upload/s--HIl4iZsO--/ablbhkc8rjnpdtqwnycl.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-firm-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Hybrid Firm Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2069,
  "compareAt": 2699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2069,
    "compareAt": 2699
   },
   "Twin XL": {
    "price": 2069,
    "compareAt": 2699
   },
   "Full": {
    "price": 2219,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
   "https://images.salsify.com/image/upload/s--jTEMl41w--/wrukyxaq5o8212xanzjn.jpg",
   "https://images.salsify.com/image/upload/s--80fhAKqV--/fkqix5ay1g5j10tcnf1g.jpg",
   "https://images.salsify.com/image/upload/s--HIl4iZsO--/ablbhkc8rjnpdtqwnycl.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-firm-mattress-set",
  "name": "Beautyrest World Class Level Four Hybrid Firm Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2069,
  "compareAt": 2699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2069,
    "compareAt": 2699
   },
   "Twin XL": {
    "price": 2069,
    "compareAt": 2699
   },
   "Full": {
    "price": 2219,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HY_KYdGU--/mkez46a4jll9z09jyugh.jpg",
   "https://images.salsify.com/image/upload/s--jTEMl41w--/wrukyxaq5o8212xanzjn.jpg",
   "https://images.salsify.com/image/upload/s--80fhAKqV--/fkqix5ay1g5j10tcnf1g.jpg",
   "https://images.salsify.com/image/upload/s--HIl4iZsO--/ablbhkc8rjnpdtqwnycl.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-plush-mattress",
  "name": "Beautyrest World Class Level Four Hybrid Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1899,
    "compareAt": 2449
   },
   "Twin XL": {
    "price": 1899,
    "compareAt": 2449
   },
   "Full": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2599,
    "compareAt": 3399
   },
   "California King": {
    "price": 2599,
    "compareAt": 3399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
   "https://images.salsify.com/image/upload/s--PoEMUeCd--/p8e4gfknr5ovcr56ytbg.jpg",
   "https://images.salsify.com/image/upload/s--ZDOjcP4D--/fp3usawm6anztpidcnos.jpg",
   "https://images.salsify.com/image/upload/s--29ClbIpr--/hgohxkllpppxemggu82e.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-plush-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Hybrid Plush Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2069,
  "compareAt": 2699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2069,
    "compareAt": 2699
   },
   "Twin XL": {
    "price": 2069,
    "compareAt": 2699
   },
   "Full": {
    "price": 2219,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
   "https://images.salsify.com/image/upload/s--PoEMUeCd--/p8e4gfknr5ovcr56ytbg.jpg",
   "https://images.salsify.com/image/upload/s--ZDOjcP4D--/fp3usawm6anztpidcnos.jpg",
   "https://images.salsify.com/image/upload/s--29ClbIpr--/hgohxkllpppxemggu82e.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-plush-mattress-set",
  "name": "Beautyrest World Class Level Four Hybrid Plush Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2069,
  "compareAt": 2699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2069,
    "compareAt": 2699
   },
   "Twin XL": {
    "price": 2069,
    "compareAt": 2699
   },
   "Full": {
    "price": 2219,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--4IDN_-gP--/nvvdgoudh6g8rslnqm9q.jpg",
   "https://images.salsify.com/image/upload/s--PoEMUeCd--/p8e4gfknr5ovcr56ytbg.jpg",
   "https://images.salsify.com/image/upload/s--ZDOjcP4D--/fp3usawm6anztpidcnos.jpg",
   "https://images.salsify.com/image/upload/s--29ClbIpr--/hgohxkllpppxemggu82e.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-medium-apex-pillowtop-mattress",
  "name": "Beautyrest World Class Level Four Hybrid Medium Apex PillowTop Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2099,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2099,
    "compareAt": 2749
   },
   "Twin XL": {
    "price": 2099,
    "compareAt": 2749
   },
   "Full": {
    "price": 2199,
    "compareAt": 2849
   },
   "Queen": {
    "price": 2299,
    "compareAt": 2999
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
   "https://images.salsify.com/image/upload/s--OHge9eUR--/ypmglhxz2aqr9n6kcgfd.jpg",
   "https://images.salsify.com/image/upload/s--cvN158WW--/etakv5sa4yatebjacieu.jpg",
   "https://images.salsify.com/image/upload/s--_XSCqtJi--/w4df18zecsvfcsnovd0f.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-medium-apex-pillowtop-mattress-low-profile-set",
  "name": "Beautyrest World Class Level Four Hybrid Medium Apex PillowTop Mattress Low Profile Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2269,
  "compareAt": 2949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2269,
    "compareAt": 2949
   },
   "Twin XL": {
    "price": 2269,
    "compareAt": 2949
   },
   "Full": {
    "price": 2419,
    "compareAt": 3149
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
   "https://images.salsify.com/image/upload/s--OHge9eUR--/ypmglhxz2aqr9n6kcgfd.jpg",
   "https://images.salsify.com/image/upload/s--cvN158WW--/etakv5sa4yatebjacieu.jpg",
   "https://images.salsify.com/image/upload/s--_XSCqtJi--/w4df18zecsvfcsnovd0f.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-world-class-level-four-hybrid-medium-apex-pillowtop-mattress-set",
  "name": "Beautyrest World Class Level Four Hybrid Medium Apex PillowTop Mattress Set",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 2269,
  "compareAt": 2949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 2269,
    "compareAt": 2949
   },
   "Twin XL": {
    "price": 2269,
    "compareAt": 2949
   },
   "Full": {
    "price": 2419,
    "compareAt": 3149
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--B_sTPnPE--/xfi0g0sydfoofxqs3ycg.jpg",
   "https://images.salsify.com/image/upload/s--OHge9eUR--/ypmglhxz2aqr9n6kcgfd.jpg",
   "https://images.salsify.com/image/upload/s--cvN158WW--/etakv5sa4yatebjacieu.jpg",
   "https://images.salsify.com/image/upload/s--_XSCqtJi--/w4df18zecsvfcsnovd0f.jpg"
  ],
  "description": "Step up to a world class sleep experience with Beautyrest World Class. Our 1000-density Pocketed Coil Technology and higher density foams provide premier individualized support + motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-5-extra-firm-mattress",
  "name": "Beautyrest Black Series One 13.5\" Extra Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1749,
  "compareAt": 2249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "13.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1749,
    "compareAt": 2249
   },
   "Full": {
    "price": 1929,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
   "https://images.salsify.com/image/upload/s--OaXRy68p--/nfhd7i0mebbso5pwoogh.jpg",
   "https://images.salsify.com/image/upload/s--muAmUxcK--/gjao0vgtymhdmpj19vwa.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-5-extra-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 13.5\" Extra Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "19.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
   "https://images.salsify.com/image/upload/s--OaXRy68p--/nfhd7i0mebbso5pwoogh.jpg",
   "https://images.salsify.com/image/upload/s--muAmUxcK--/gjao0vgtymhdmpj19vwa.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-5-extra-firm-mattress-set",
  "name": "Beautyrest Black Series One 13.5\" Extra Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "22.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ZkwN71zR--/i1h3ia5acwctbfvctith.jpg",
   "https://images.salsify.com/image/upload/s--OaXRy68p--/nfhd7i0mebbso5pwoogh.jpg",
   "https://images.salsify.com/image/upload/s--muAmUxcK--/gjao0vgtymhdmpj19vwa.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-medium-mattress",
  "name": "Beautyrest Black Series One 14.25\" Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1749,
  "compareAt": 2249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1749,
    "compareAt": 2249
   },
   "Full": {
    "price": 1929,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
   "https://images.salsify.com/image/upload/s--bTQp_rF6--/qzsyozf5xbblsbpbtloi.jpg",
   "https://images.salsify.com/image/upload/s--NhST9HSb--/bpox3wobq6ejlrd3kc0f.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-medium-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 14.25\" Medium Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
   "https://images.salsify.com/image/upload/s--bTQp_rF6--/qzsyozf5xbblsbpbtloi.jpg",
   "https://images.salsify.com/image/upload/s--NhST9HSb--/bpox3wobq6ejlrd3kc0f.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-medium-mattress-set",
  "name": "Beautyrest Black Series One 14.25\" Medium Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TjUHFrcW--/f4mn593ovea8iaveeekh.jpg",
   "https://images.salsify.com/image/upload/s--bTQp_rF6--/qzsyozf5xbblsbpbtloi.jpg",
   "https://images.salsify.com/image/upload/s--NhST9HSb--/bpox3wobq6ejlrd3kc0f.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-plush-mattress",
  "name": "Beautyrest Black Series One 14\" Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1749,
  "compareAt": 2249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1749,
    "compareAt": 2249
   },
   "Full": {
    "price": 1929,
    "compareAt": 2499
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
   "https://images.salsify.com/image/upload/s--iVlM_Xzq--/fn1ftcmkkxqssmtbiyfn.jpg",
   "https://images.salsify.com/image/upload/s--G0CFpn0_--/kbwpouuxxav4hqlljdx6.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-plush-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 14\" Plush Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
   "https://images.salsify.com/image/upload/s--iVlM_Xzq--/fn1ftcmkkxqssmtbiyfn.jpg",
   "https://images.salsify.com/image/upload/s--G0CFpn0_--/kbwpouuxxav4hqlljdx6.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-plush-mattress-set",
  "name": "Beautyrest Black Series One 14\" Plush Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1919,
  "compareAt": 2499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1919,
    "compareAt": 2499
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3139,
    "compareAt": 4099
   },
   "California King": {
    "price": 3139,
    "compareAt": 4099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--pAiUdLJJ--/sg8hdptldedryuota2aq.jpg",
   "https://images.salsify.com/image/upload/s--iVlM_Xzq--/fn1ftcmkkxqssmtbiyfn.jpg",
   "https://images.salsify.com/image/upload/s--G0CFpn0_--/kbwpouuxxav4hqlljdx6.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-75-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series One 14.75\" Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2399,
    "compareAt": 3099
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
   "https://images.salsify.com/image/upload/s--UW4sFIhg--/jqtrt6wctxghoiawyopa.jpg",
   "https://images.salsify.com/image/upload/s--Hoxoh1aJ--/az3yemuqwhtusdj8yi9x.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-75-medium-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 14.75\" Medium Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
   "https://images.salsify.com/image/upload/s--UW4sFIhg--/jqtrt6wctxghoiawyopa.jpg",
   "https://images.salsify.com/image/upload/s--Hoxoh1aJ--/az3yemuqwhtusdj8yi9x.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-75-medium-pillow-top-mattress-set",
  "name": "Beautyrest Black Series One 14.75\" Medium Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FfxDWzjO--/uctbwg55udks8tooceu1.jpg",
   "https://images.salsify.com/image/upload/s--UW4sFIhg--/jqtrt6wctxghoiawyopa.jpg",
   "https://images.salsify.com/image/upload/s--Hoxoh1aJ--/az3yemuqwhtusdj8yi9x.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-5-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series One 14.5\" Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2399,
    "compareAt": 3099
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
   "https://images.salsify.com/image/upload/s--odUtLaId--/xds1rioepk8wtb4sl5ur.jpg",
   "https://images.salsify.com/image/upload/s--1hmNg-ZA--/wf8o8ru7dipcwatppdzt.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-5-plush-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 14.5\" Plush Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
   "https://images.salsify.com/image/upload/s--odUtLaId--/xds1rioepk8wtb4sl5ur.jpg",
   "https://images.salsify.com/image/upload/s--1hmNg-ZA--/wf8o8ru7dipcwatppdzt.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-5-plush-pillow-top-mattress-set",
  "name": "Beautyrest Black Series One 14.5\" Plush Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--wdXcBqw0--/yccsbtc4elpukszmmixh.jpg",
   "https://images.salsify.com/image/upload/s--odUtLaId--/xds1rioepk8wtb4sl5ur.jpg",
   "https://images.salsify.com/image/upload/s--1hmNg-ZA--/wf8o8ru7dipcwatppdzt.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-5-medium-mattress",
  "name": "Beautyrest Black Series Two 15.5\" Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2349,
  "compareAt": 3049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2349,
    "compareAt": 3049
   },
   "Full": {
    "price": 2629,
    "compareAt": 3399
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3649
   },
   "King": {
    "price": 3499,
    "compareAt": 4549
   },
   "California King": {
    "price": 3499,
    "compareAt": 4549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
   "https://images.salsify.com/image/upload/s--NpaWm7Bb--/ztpvt3sofav5xrz4onjq.jpg",
   "https://images.salsify.com/image/upload/s--5agq31Is--/tkods2zx9apk8x73tiyr.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-5-medium-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 15.5\" Medium Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
   "https://images.salsify.com/image/upload/s--NpaWm7Bb--/ztpvt3sofav5xrz4onjq.jpg",
   "https://images.salsify.com/image/upload/s--5agq31Is--/tkods2zx9apk8x73tiyr.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-5-medium-mattress-set",
  "name": "Beautyrest Black Series Two 15.5\" Medium Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--gTMuF2QY--/vyno0xrqojzedmlqd54t.jpg",
   "https://images.salsify.com/image/upload/s--NpaWm7Bb--/ztpvt3sofav5xrz4onjq.jpg",
   "https://images.salsify.com/image/upload/s--5agq31Is--/tkods2zx9apk8x73tiyr.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-25-plush-mattress",
  "name": "Beautyrest Black Series Two 15.25\" Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2349,
  "compareAt": 3049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2349,
    "compareAt": 3049
   },
   "Full": {
    "price": 2629,
    "compareAt": 3399
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3649
   },
   "King": {
    "price": 3499,
    "compareAt": 4549
   },
   "California King": {
    "price": 3499,
    "compareAt": 4549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
   "https://images.salsify.com/image/upload/s--qAhBX1GZ--/mvoypgcsqhgju6u0r75h.jpg",
   "https://images.salsify.com/image/upload/s--xRV-Qcrn--/lhu8lvoyewiuc9szv9di.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-25-plush-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 15.25\" Plush Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
   "https://images.salsify.com/image/upload/s--qAhBX1GZ--/mvoypgcsqhgju6u0r75h.jpg",
   "https://images.salsify.com/image/upload/s--xRV-Qcrn--/lhu8lvoyewiuc9szv9di.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-15-25-plush-mattress-set",
  "name": "Beautyrest Black Series Two 15.25\" Plush Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WtFVcKv8--/tjqvjtvnggckh2uv0q7p.jpg",
   "https://images.salsify.com/image/upload/s--qAhBX1GZ--/mvoypgcsqhgju6u0r75h.jpg",
   "https://images.salsify.com/image/upload/s--xRV-Qcrn--/lhu8lvoyewiuc9szv9di.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-5-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series Two 16.5\" Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2949,
  "compareAt": 3849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "16.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2949,
    "compareAt": 3849
   },
   "Full": {
    "price": 3229,
    "compareAt": 4199
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 3699,
    "compareAt": 4799
   },
   "California King": {
    "price": 3699,
    "compareAt": 4799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
   "https://images.salsify.com/image/upload/s--7AIXOLND--/l3mkxqxp0sxys0ncp6nd.jpg",
   "https://images.salsify.com/image/upload/s--cSLNe6nF--/gehdskoq4nhwaamqy54q.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-5-medium-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 16.5\" Medium Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4039,
    "compareAt": 5249
   },
   "California King": {
    "price": 4039,
    "compareAt": 5249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
   "https://images.salsify.com/image/upload/s--7AIXOLND--/l3mkxqxp0sxys0ncp6nd.jpg",
   "https://images.salsify.com/image/upload/s--cSLNe6nF--/gehdskoq4nhwaamqy54q.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-5-medium-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Two 16.5\" Medium Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "25.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4039,
    "compareAt": 5249
   },
   "California King": {
    "price": 4039,
    "compareAt": 5249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--zwAgQX9P--/pjg0z8cz1rblhtsnswfk.jpg",
   "https://images.salsify.com/image/upload/s--7AIXOLND--/l3mkxqxp0sxys0ncp6nd.jpg",
   "https://images.salsify.com/image/upload/s--cSLNe6nF--/gehdskoq4nhwaamqy54q.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-25-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series Two 16.25\" Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2949,
  "compareAt": 3849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2949,
    "compareAt": 3849
   },
   "Full": {
    "price": 3229,
    "compareAt": 4199
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 3699,
    "compareAt": 4799
   },
   "California King": {
    "price": 3699,
    "compareAt": 4799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
   "https://images.salsify.com/image/upload/s--J-QlYOfL--/mmgbbbepk66ybhkfvvfj.jpg",
   "https://images.salsify.com/image/upload/s--AbVyMEWt--/ezgrol3ff9cbg7z9tozp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-25-plush-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 16.25\" Plush Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4039,
    "compareAt": 5249
   },
   "California King": {
    "price": 4039,
    "compareAt": 5249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
   "https://images.salsify.com/image/upload/s--J-QlYOfL--/mmgbbbepk66ybhkfvvfj.jpg",
   "https://images.salsify.com/image/upload/s--AbVyMEWt--/ezgrol3ff9cbg7z9tozp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-16-25-plush-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Two 16.25\" Plush Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4039,
    "compareAt": 5249
   },
   "California King": {
    "price": 4039,
    "compareAt": 5249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Q8UYbkBL--/rvqzhpbunnjm9fgbm67i.jpg",
   "https://images.salsify.com/image/upload/s--J-QlYOfL--/mmgbbbepk66ybhkfvvfj.jpg",
   "https://images.salsify.com/image/upload/s--AbVyMEWt--/ezgrol3ff9cbg7z9tozp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-firm-mattress",
  "name": "Beautyrest Black Series Three 15\" Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "15\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3699
   },
   "Full": {
    "price": 3129,
    "compareAt": 4049
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--1RsfrI-I--/tjplguoxz739upqr3hok.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 15\" Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "21\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--1RsfrI-I--/tjplguoxz739upqr3hok.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-firm-mattress-set",
  "name": "Beautyrest Black Series Three 15\" Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "24\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TcrK-s4N--/eifvcge0dgapap3kxqrm.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--1RsfrI-I--/tjplguoxz739upqr3hok.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-25-medium-mattress",
  "name": "Beautyrest Black Series Three 15.25\" Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3699
   },
   "Full": {
    "price": 3129,
    "compareAt": 4049
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
   "https://images.salsify.com/image/upload/s--rxFmDF1N--/aakc0a7sv5i5nthypac2.jpg",
   "https://images.salsify.com/image/upload/s--AkgbphHg--/yrcrmtjhhqymw2fbrmwv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-25-medium-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 15.25\" Medium Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
   "https://images.salsify.com/image/upload/s--rxFmDF1N--/aakc0a7sv5i5nthypac2.jpg",
   "https://images.salsify.com/image/upload/s--AkgbphHg--/yrcrmtjhhqymw2fbrmwv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-25-medium-mattress-set",
  "name": "Beautyrest Black Series Three 15.25\" Medium Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DEKQ5z7G--/xqiyh2wxukbmjfopvbtz.jpg",
   "https://images.salsify.com/image/upload/s--rxFmDF1N--/aakc0a7sv5i5nthypac2.jpg",
   "https://images.salsify.com/image/upload/s--AkgbphHg--/yrcrmtjhhqymw2fbrmwv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-25-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series Three 16.25\" Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "16.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4599,
    "compareAt": 5999
   },
   "California King": {
    "price": 4599,
    "compareAt": 5999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
   "https://images.salsify.com/image/upload/s--Zdv4FeMO--/kg2bp7ls72f54ysmudnw.jpg",
   "https://images.salsify.com/image/upload/s--wKCTXGfl--/sz5huuaweo3guww5blq2.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-25-medium-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 16.25\" Medium Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
   "https://images.salsify.com/image/upload/s--Zdv4FeMO--/kg2bp7ls72f54ysmudnw.jpg",
   "https://images.salsify.com/image/upload/s--wKCTXGfl--/sz5huuaweo3guww5blq2.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-25-medium-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Three 16.25\" Medium Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "25.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--FuOEEUvy--/h8oymlfb7005diay2qh1.jpg",
   "https://images.salsify.com/image/upload/s--Zdv4FeMO--/kg2bp7ls72f54ysmudnw.jpg",
   "https://images.salsify.com/image/upload/s--wKCTXGfl--/sz5huuaweo3guww5blq2.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-75-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series Three 16.75\" Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4599,
    "compareAt": 5999
   },
   "California King": {
    "price": 4599,
    "compareAt": 5999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
   "https://images.salsify.com/image/upload/s--Kc7ktFq---/hphnhwrynarrrymtmx7s.jpg",
   "https://images.salsify.com/image/upload/s--AuRY3U76--/yovqmon8blmtwc8lrjgv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-75-plush-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 16.75\" Plush Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
   "https://images.salsify.com/image/upload/s--Kc7ktFq---/hphnhwrynarrrymtmx7s.jpg",
   "https://images.salsify.com/image/upload/s--AuRY3U76--/yovqmon8blmtwc8lrjgv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-75-plush-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Three 16.75\" Plush Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--WW4MZ1Ww--/pkw5nqorf6gwo5wixrub.jpg",
   "https://images.salsify.com/image/upload/s--Kc7ktFq---/hphnhwrynarrrymtmx7s.jpg",
   "https://images.salsify.com/image/upload/s--AuRY3U76--/yovqmon8blmtwc8lrjgv.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-25-plush-summit-pillow-top-mattress",
  "name": "Beautyrest Black Series Four 17.25\" Plush Summit Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 5499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "17.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 5499
   },
   "Full": {
    "price": 4529,
    "compareAt": 5899
   },
   "Queen": {
    "price": 4899,
    "compareAt": 6349
   },
   "King": {
    "price": 5899,
    "compareAt": 7649
   },
   "California King": {
    "price": 5899,
    "compareAt": 7649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
   "https://images.salsify.com/image/upload/s--BExivdVJ--/o8ordgu1pqgsk1dwdbzu.jpg",
   "https://images.salsify.com/image/upload/s--KtC2yeH4--/ckvlx7uia21szl2fvzrs.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-25-plush-summit-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Four 17.25\" Plush Summit Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
   "https://images.salsify.com/image/upload/s--BExivdVJ--/o8ordgu1pqgsk1dwdbzu.jpg",
   "https://images.salsify.com/image/upload/s--KtC2yeH4--/ckvlx7uia21szl2fvzrs.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-25-plush-summit-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Four 17.25\" Plush Summit Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "26.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6IUKWv79--/ki7gmpkzrha0gycu8sba.jpg",
   "https://images.salsify.com/image/upload/s--BExivdVJ--/o8ordgu1pqgsk1dwdbzu.jpg",
   "https://images.salsify.com/image/upload/s--KtC2yeH4--/ckvlx7uia21szl2fvzrs.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-medium-summit-pillow-top-mattress",
  "name": "Beautyrest Black Series Four 17.5\" Medium Summit Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 5499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "17.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 5499
   },
   "Full": {
    "price": 4529,
    "compareAt": 5899
   },
   "Queen": {
    "price": 4899,
    "compareAt": 6349
   },
   "King": {
    "price": 5899,
    "compareAt": 7649
   },
   "California King": {
    "price": 5899,
    "compareAt": 7649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
   "https://images.salsify.com/image/upload/s--1pSdZQC2--/fujrmfpesl0hxuoa7f6k.jpg",
   "https://images.salsify.com/image/upload/s--uTHGOsgD--/prjp5ahwbedvacyoeked.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-medium-summit-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Four 17.5\" Medium Summit Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
   "https://images.salsify.com/image/upload/s--1pSdZQC2--/fujrmfpesl0hxuoa7f6k.jpg",
   "https://images.salsify.com/image/upload/s--uTHGOsgD--/prjp5ahwbedvacyoeked.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-medium-summit-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Four 17.5\" Medium Summit Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "26.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--oF7ISU5m--/gsjfli7j0i7gfk5gqv7a.jpg",
   "https://images.salsify.com/image/upload/s--1pSdZQC2--/fujrmfpesl0hxuoa7f6k.jpg",
   "https://images.salsify.com/image/upload/s--uTHGOsgD--/prjp5ahwbedvacyoeked.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-25-firm-mattress",
  "name": "Beautyrest Black Series Two 14.25\" Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2349,
  "compareAt": 3049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2349,
    "compareAt": 3049
   },
   "Full": {
    "price": 2629,
    "compareAt": 3399
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3649
   },
   "King": {
    "price": 3499,
    "compareAt": 4549
   },
   "California King": {
    "price": 3499,
    "compareAt": 4549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
   "https://images.salsify.com/image/upload/s--y5YjwGqa--/erjov5pbrbpymd6sbrfl.jpg",
   "https://images.salsify.com/image/upload/s--C9MEi9BZ--/grlvql8hflnqsrcf16gp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-25-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 14.25\" Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "20.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
   "https://images.salsify.com/image/upload/s--y5YjwGqa--/erjov5pbrbpymd6sbrfl.jpg",
   "https://images.salsify.com/image/upload/s--C9MEi9BZ--/grlvql8hflnqsrcf16gp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-25-firm-mattress-set",
  "name": "Beautyrest Black Series Two 14.25\" Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2519,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2519,
    "compareAt": 3249
   },
   "Full": {
    "price": 2849,
    "compareAt": 3699
   },
   "Queen": {
    "price": 3019,
    "compareAt": 3899
   },
   "King": {
    "price": 3839,
    "compareAt": 4999
   },
   "California King": {
    "price": 3839,
    "compareAt": 4999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vgWQZ_4S--/qatr5asapfqce1kptbsy.jpg",
   "https://images.salsify.com/image/upload/s--y5YjwGqa--/erjov5pbrbpymd6sbrfl.jpg",
   "https://images.salsify.com/image/upload/s--C9MEi9BZ--/grlvql8hflnqsrcf16gp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series Four 17.5\" Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 5499,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "17.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 5499
   },
   "Full": {
    "price": 4529,
    "compareAt": 5899
   },
   "Queen": {
    "price": 4899,
    "compareAt": 6349
   },
   "King": {
    "price": 5899,
    "compareAt": 7649
   },
   "California King": {
    "price": 5899,
    "compareAt": 7649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
   "https://images.salsify.com/image/upload/s--RF9XbvJQ--/vwizgsplpddrkw5qgcpj.jpg",
   "https://images.salsify.com/image/upload/s--KGQR303p--/f7lw9znmbttif55vmkyp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-firm-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Four 17.5\" Firm Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "23.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
   "https://images.salsify.com/image/upload/s--RF9XbvJQ--/vwizgsplpddrkw5qgcpj.jpg",
   "https://images.salsify.com/image/upload/s--KGQR303p--/f7lw9znmbttif55vmkyp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-17-5-firm-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Four 17.5\" Firm Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4419,
  "compareAt": 5749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "26.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4419,
    "compareAt": 5749
   },
   "Full": {
    "price": 4749,
    "compareAt": 6149
   },
   "Queen": {
    "price": 5119,
    "compareAt": 6649
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--x0pOrLPd--/hmbhbbhsgalu73vpxat2.jpg",
   "https://images.salsify.com/image/upload/s--RF9XbvJQ--/vwizgsplpddrkw5qgcpj.jpg",
   "https://images.salsify.com/image/upload/s--KGQR303p--/f7lw9znmbttif55vmkyp.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, Self-Response Latex, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series One 14.25\" Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2399,
    "compareAt": 3099
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
   "https://images.salsify.com/image/upload/s---OImVKm1--/lc19qpaii0w8mkuq0zsy.jpg",
   "https://images.salsify.com/image/upload/s--daxtxS8V--/tjmbsb6afg8dijvvc1y3.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-firm-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 14.25\" Firm Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "20.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
   "https://images.salsify.com/image/upload/s---OImVKm1--/lc19qpaii0w8mkuq0zsy.jpg",
   "https://images.salsify.com/image/upload/s--daxtxS8V--/tjmbsb6afg8dijvvc1y3.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-14-25-firm-pillow-top-mattress-set",
  "name": "Beautyrest Black Series One 14.25\" Firm Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2619,
    "compareAt": 3399
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Xx2owz89--/oxfctzj47hxjzhgiwugy.jpg",
   "https://images.salsify.com/image/upload/s---OImVKm1--/lc19qpaii0w8mkuq0zsy.jpg",
   "https://images.salsify.com/image/upload/s--daxtxS8V--/tjmbsb6afg8dijvvc1y3.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, premium foams, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-25-extra-firm-mattress",
  "name": "Beautyrest Black Series Three 14.25\" Extra Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3699
   },
   "Full": {
    "price": 3129,
    "compareAt": 4049
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--tBAL2CBc--/yi9iwiq1rrkrfwapjeea.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-25-extra-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 14.25\" Extra Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "20.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--tBAL2CBc--/yi9iwiq1rrkrfwapjeea.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-25-extra-firm-mattress-set",
  "name": "Beautyrest Black Series Three 14.25\" Extra Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3019,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "23.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3019,
    "compareAt": 3899
   },
   "Full": {
    "price": 3349,
    "compareAt": 4349
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--duKBjyxk--/nnvfadbdqo7uxlwxljg3.jpg",
   "https://images.salsify.com/image/upload/s--4v4rvXS0--/j3jztfnra4115k2ki5uj.jpg",
   "https://images.salsify.com/image/upload/s--tBAL2CBc--/yi9iwiq1rrkrfwapjeea.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-5-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series Three 16.5\" Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "16.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4599,
    "compareAt": 5999
   },
   "California King": {
    "price": 4599,
    "compareAt": 5999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
   "https://images.salsify.com/image/upload/s--RmSWR0_y--/b1feyun1iurxugmfpo5l.jpg",
   "https://images.salsify.com/image/upload/s--_7yDGwX7--/awxwjwnxmhvsg5hy7hs4.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-5-firm-pillow-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 16.5\" Firm Pillow Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
   "https://images.salsify.com/image/upload/s--RmSWR0_y--/b1feyun1iurxugmfpo5l.jpg",
   "https://images.salsify.com/image/upload/s--_7yDGwX7--/awxwjwnxmhvsg5hy7hs4.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-16-5-firm-pillow-top-mattress-set",
  "name": "Beautyrest Black Series Three 16.5\" Firm Pillow Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "25.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4939,
    "compareAt": 6399
   },
   "California King": {
    "price": 4939,
    "compareAt": 6399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--smL5fepY--/dxqkxt6yg0lczq2jywy2.jpg",
   "https://images.salsify.com/image/upload/s--RmSWR0_y--/b1feyun1iurxugmfpo5l.jpg",
   "https://images.salsify.com/image/upload/s--_7yDGwX7--/awxwjwnxmhvsg5hy7hs4.jpg",
   "https://images.salsify.com/image/upload/s--mBwnbrv3--/ntnddeb8i70j3zd33iuw.jpg"
  ],
  "description": "Experience the best of Beautyrest, featuring advanced temperature management technology, Micro Diamond Memory Foam, and advanced, Triple-Stranded Pocketed Coil Technology for conforming support and motion separation. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-plush-mattress",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "12.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
   "https://images.salsify.com/image/upload/s--EtKazL8Z--/grjhh8fj0f9zdh3prrfn.jpg",
   "https://images.salsify.com/image/upload/s--uah5bLdW--/rqydc93w9b6qgqbar0xv.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-plush-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Plush Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "18.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
   "https://images.salsify.com/image/upload/s--EtKazL8Z--/grjhh8fj0f9zdh3prrfn.jpg",
   "https://images.salsify.com/image/upload/s--uah5bLdW--/rqydc93w9b6qgqbar0xv.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-plush-mattress-set",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Plush Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--1fgagGSK--/vkte79ztipk3cdu7nlta.jpg",
   "https://images.salsify.com/image/upload/s--EtKazL8Z--/grjhh8fj0f9zdh3prrfn.jpg",
   "https://images.salsify.com/image/upload/s--uah5bLdW--/rqydc93w9b6qgqbar0xv.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-firm-mattress",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "12.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
   "https://images.salsify.com/image/upload/s--BOXZTA5I--/lqtcuhox2eedh9c6gvhd.jpg",
   "https://images.salsify.com/image/upload/s--QhZQN6l9--/kufeuxhp6vhqowv5bkcz.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "18.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
   "https://images.salsify.com/image/upload/s--BOXZTA5I--/lqtcuhox2eedh9c6gvhd.jpg",
   "https://images.salsify.com/image/upload/s--QhZQN6l9--/kufeuxhp6vhqowv5bkcz.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-12-5-hybrid-firm-mattress-set",
  "name": "Beautyrest Black Series One 12.5\" Hybrid Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "21.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vTpNQWSx--/nhihjihuks9iy3vsvjtp.jpg",
   "https://images.salsify.com/image/upload/s--BOXZTA5I--/lqtcuhox2eedh9c6gvhd.jpg",
   "https://images.salsify.com/image/upload/s--QhZQN6l9--/kufeuxhp6vhqowv5bkcz.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-hybrid-medium-mattress",
  "name": "Beautyrest Black Series One 13\" Hybrid Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1949,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1949,
    "compareAt": 2549
   },
   "Full": {
    "price": 2229,
    "compareAt": 2899
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
   "https://images.salsify.com/image/upload/s--TFxVryhS--/g6cgi167t0zub1n4txee.jpg",
   "https://images.salsify.com/image/upload/s--tNmmdmEB--/hrsqfqgdptvflpfej0s7.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-hybrid-medium-mattress-low-profile-set",
  "name": "Beautyrest Black Series One 13\" Hybrid Medium Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
   "https://images.salsify.com/image/upload/s--TFxVryhS--/g6cgi167t0zub1n4txee.jpg",
   "https://images.salsify.com/image/upload/s--tNmmdmEB--/hrsqfqgdptvflpfej0s7.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-one-13-hybrid-medium-mattress-set",
  "name": "Beautyrest Black Series One 13\" Hybrid Medium Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2119,
  "compareAt": 2749,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2119,
    "compareAt": 2749
   },
   "Full": {
    "price": 2449,
    "compareAt": 3199
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5tiFRA1h--/lxdhpjd0ghqv5wpzvoi9.jpg",
   "https://images.salsify.com/image/upload/s--TFxVryhS--/g6cgi167t0zub1n4txee.jpg",
   "https://images.salsify.com/image/upload/s--tNmmdmEB--/hrsqfqgdptvflpfej0s7.jpg",
   "https://images.salsify.com/image/upload/s--d717TPZI--/btonotlffmjueypfq4zy.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-firm-mattress",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2949,
  "compareAt": 3849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2949,
    "compareAt": 3849
   },
   "Full": {
    "price": 3229,
    "compareAt": 4199
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 4099,
    "compareAt": 5349
   },
   "California King": {
    "price": 4099,
    "compareAt": 5349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
   "https://images.salsify.com/image/upload/s--hnOuAIdC--/af4irl25q3juqjyoecql.jpg",
   "https://images.salsify.com/image/upload/s--hMe2EltI--/xyrfcnntsn9qmdpmyoda.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4439,
    "compareAt": 5749
   },
   "California King": {
    "price": 4439,
    "compareAt": 5749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
   "https://images.salsify.com/image/upload/s--hnOuAIdC--/af4irl25q3juqjyoecql.jpg",
   "https://images.salsify.com/image/upload/s--hMe2EltI--/xyrfcnntsn9qmdpmyoda.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-firm-mattress-set",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4439,
    "compareAt": 5749
   },
   "California King": {
    "price": 4439,
    "compareAt": 5749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SEA-Db8y--/vj7rnx4o5rul8lxszajy.jpg",
   "https://images.salsify.com/image/upload/s--hnOuAIdC--/af4irl25q3juqjyoecql.jpg",
   "https://images.salsify.com/image/upload/s--hMe2EltI--/xyrfcnntsn9qmdpmyoda.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-plush-mattress",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2949,
  "compareAt": 3849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2949,
    "compareAt": 3849
   },
   "Full": {
    "price": 3229,
    "compareAt": 4199
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 4099,
    "compareAt": 5349
   },
   "California King": {
    "price": 4099,
    "compareAt": 5349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
   "https://images.salsify.com/image/upload/s--ASlLVb_f--/dcqjdrh50hpq253su9um.jpg",
   "https://images.salsify.com/image/upload/s--oit8Nlfn--/bzcaqmbf0vbpdzijjrkw.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-plush-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Plush Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4439,
    "compareAt": 5749
   },
   "California King": {
    "price": 4439,
    "compareAt": 5749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
   "https://images.salsify.com/image/upload/s--ASlLVb_f--/dcqjdrh50hpq253su9um.jpg",
   "https://images.salsify.com/image/upload/s--oit8Nlfn--/bzcaqmbf0vbpdzijjrkw.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-13-5-hybrid-plush-mattress-set",
  "name": "Beautyrest Black Series Two 13.5\" Hybrid Plush Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4439,
    "compareAt": 5749
   },
   "California King": {
    "price": 4439,
    "compareAt": 5749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--MTdfW4E7--/bgzpeh1jhy0bhyinumym.jpg",
   "https://images.salsify.com/image/upload/s--ASlLVb_f--/dcqjdrh50hpq253su9um.jpg",
   "https://images.salsify.com/image/upload/s--oit8Nlfn--/bzcaqmbf0vbpdzijjrkw.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-5-hybrid-medium-apex-top-mattress",
  "name": "Beautyrest Black Series Two 14.5\" Hybrid Medium Apex Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2949,
  "compareAt": 3849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2949,
    "compareAt": 3849
   },
   "Full": {
    "price": 3229,
    "compareAt": 4199
   },
   "Queen": {
    "price": 3399,
    "compareAt": 4399
   },
   "King": {
    "price": 3999,
    "compareAt": 5199
   },
   "California King": {
    "price": 3999,
    "compareAt": 5199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
   "https://images.salsify.com/image/upload/s--npL2WsIv--/npwz1imelederssvbqtn.jpg",
   "https://images.salsify.com/image/upload/s--9kE6jPkT--/c46d2flp9vmf4uvbvpw9.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-5-hybrid-medium-apex-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Two 14.5\" Hybrid Medium Apex Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4339,
    "compareAt": 5649
   },
   "California King": {
    "price": 4339,
    "compareAt": 5649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
   "https://images.salsify.com/image/upload/s--npL2WsIv--/npwz1imelederssvbqtn.jpg",
   "https://images.salsify.com/image/upload/s--9kE6jPkT--/c46d2flp9vmf4uvbvpw9.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-two-14-5-hybrid-medium-apex-top-mattress-set",
  "name": "Beautyrest Black Series Two 14.5\" Hybrid Medium Apex Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3119,
  "compareAt": 4049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3119,
    "compareAt": 4049
   },
   "Full": {
    "price": 3449,
    "compareAt": 4499
   },
   "Queen": {
    "price": 3619,
    "compareAt": 4699
   },
   "King": {
    "price": 4339,
    "compareAt": 5649
   },
   "California King": {
    "price": 4339,
    "compareAt": 5649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HR4uMe0j--/s9yx9esstvvsubmmwujn.jpg",
   "https://images.salsify.com/image/upload/s--npL2WsIv--/npwz1imelederssvbqtn.jpg",
   "https://images.salsify.com/image/upload/s--9kE6jPkT--/c46d2flp9vmf4uvbvpw9.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-firm-mattress",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4499,
    "compareAt": 5849
   },
   "California King": {
    "price": 4499,
    "compareAt": 5849
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
   "https://images.salsify.com/image/upload/s--2fcXiDU0--/tbeubmz6wqtwxnj5vwg3.jpg",
   "https://images.salsify.com/image/upload/s--D5qfkzMh--/pmvnrfqvyai3i5fhzr3e.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-firm-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Firm Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "20.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
   "https://images.salsify.com/image/upload/s--2fcXiDU0--/tbeubmz6wqtwxnj5vwg3.jpg",
   "https://images.salsify.com/image/upload/s--D5qfkzMh--/pmvnrfqvyai3i5fhzr3e.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-firm-mattress-set",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Firm Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "23.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--6Z4-T61k--/tsxafmjzm2xehokawxfo.jpg",
   "https://images.salsify.com/image/upload/s--2fcXiDU0--/tbeubmz6wqtwxnj5vwg3.jpg",
   "https://images.salsify.com/image/upload/s--D5qfkzMh--/pmvnrfqvyai3i5fhzr3e.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-plush-mattress",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4499,
    "compareAt": 5849
   },
   "California King": {
    "price": 4499,
    "compareAt": 5849
   }
  },
  "image": "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
   "https://images.salsify.com/image/upload/s--tKiyg6Mm--/hjxn9iiiy7xknq2f2mjq.jpg",
   "https://images.salsify.com/image/upload/s--j1nvpaEF--/ocfxxtl7n8rutdzwxoa2.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-plush-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Plush Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
   "https://images.salsify.com/image/upload/s--tKiyg6Mm--/hjxn9iiiy7xknq2f2mjq.jpg",
   "https://images.salsify.com/image/upload/s--j1nvpaEF--/ocfxxtl7n8rutdzwxoa2.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-14-5-hybrid-plush-mattress-set",
  "name": "Beautyrest Black Series Three 14.5\" Hybrid Plush Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--7_-T8p_e--/pbwujdmruqbdu5zt8tsz.jpg",
   "https://images.salsify.com/image/upload/s--tKiyg6Mm--/hjxn9iiiy7xknq2f2mjq.jpg",
   "https://images.salsify.com/image/upload/s--j1nvpaEF--/ocfxxtl7n8rutdzwxoa2.jpg",
   "https://images.salsify.com/image/upload/s--8I1qVhJs--/mikzooipfbjskc68zc7z.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-hybrid-medium-mattress",
  "name": "Beautyrest Black Series Three 15\" Hybrid Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 4199,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 4199
   },
   "Full": {
    "price": 3529,
    "compareAt": 4599
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4949
   },
   "King": {
    "price": 4499,
    "compareAt": 5849
   },
   "California King": {
    "price": 4499,
    "compareAt": 5849
   }
  },
  "image": "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
   "https://images.salsify.com/image/upload/s--BKL6VcGE--/e7avxjhgafasuzjkovhe.jpg",
   "https://images.salsify.com/image/upload/s--XO5XXvjv--/y3fyqnpvow2eqylkhjbw.jpg",
   "https://images.salsify.com/image/upload/s--2e7rhuHw--/n756fl9aao4ri9eykfam.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-hybrid-medium-mattress-low-profile-set",
  "name": "Beautyrest Black Series Three 15\" Hybrid Medium Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
   "https://images.salsify.com/image/upload/s--BKL6VcGE--/e7avxjhgafasuzjkovhe.jpg",
   "https://images.salsify.com/image/upload/s--XO5XXvjv--/y3fyqnpvow2eqylkhjbw.jpg",
   "https://images.salsify.com/image/upload/s--2e7rhuHw--/n756fl9aao4ri9eykfam.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-three-15-hybrid-medium-mattress-set",
  "name": "Beautyrest Black Series Three 15\" Hybrid Medium Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3419,
  "compareAt": 4449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3419,
    "compareAt": 4449
   },
   "Full": {
    "price": 3749,
    "compareAt": 4849
   },
   "Queen": {
    "price": 4019,
    "compareAt": 5199
   },
   "King": {
    "price": 4839,
    "compareAt": 6299
   },
   "California King": {
    "price": 4839,
    "compareAt": 6299
   }
  },
  "image": "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--AwlkNxh1--/lczvrra7tkomxqahw9bn.jpg",
   "https://images.salsify.com/image/upload/s--BKL6VcGE--/e7avxjhgafasuzjkovhe.jpg",
   "https://images.salsify.com/image/upload/s--XO5XXvjv--/y3fyqnpvow2eqylkhjbw.jpg",
   "https://images.salsify.com/image/upload/s--2e7rhuHw--/n756fl9aao4ri9eykfam.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-firm-apex-top-mattress",
  "name": "Beautyrest Black Series Four 16\" Hybrid Firm Apex Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4949,
  "compareAt": 6449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "16\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4949,
    "compareAt": 6449
   },
   "Full": {
    "price": 5229,
    "compareAt": 6799
   },
   "Queen": {
    "price": 5599,
    "compareAt": 7299
   },
   "King": {
    "price": 6599,
    "compareAt": 8599
   },
   "California King": {
    "price": 6599,
    "compareAt": 8599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
   "https://images.salsify.com/image/upload/s--VMzt-Pri--/i8csjeucz1b0mvqxi0bb.jpg",
   "https://images.salsify.com/image/upload/s--btnYscia--/wgwlfxubofjokkrjcf0m.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-firm-apex-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Four 16\" Hybrid Firm Apex Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 5119,
  "compareAt": 6649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 5119,
    "compareAt": 6649
   },
   "Full": {
    "price": 5449,
    "compareAt": 7099
   },
   "Queen": {
    "price": 5819,
    "compareAt": 7549
   },
   "King": {
    "price": 6939,
    "compareAt": 8999
   },
   "California King": {
    "price": 6939,
    "compareAt": 8999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
   "https://images.salsify.com/image/upload/s--VMzt-Pri--/i8csjeucz1b0mvqxi0bb.jpg",
   "https://images.salsify.com/image/upload/s--btnYscia--/wgwlfxubofjokkrjcf0m.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-firm-apex-top-mattress-set",
  "name": "Beautyrest Black Series Four 16\" Hybrid Firm Apex Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 5119,
  "compareAt": 6649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 5119,
    "compareAt": 6649
   },
   "Full": {
    "price": 5449,
    "compareAt": 7099
   },
   "Queen": {
    "price": 5819,
    "compareAt": 7549
   },
   "King": {
    "price": 6939,
    "compareAt": 8999
   },
   "California King": {
    "price": 6939,
    "compareAt": 8999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vGG2dH2k--/lpsuft724qivx6pvxn7l.jpg",
   "https://images.salsify.com/image/upload/s--VMzt-Pri--/i8csjeucz1b0mvqxi0bb.jpg",
   "https://images.salsify.com/image/upload/s--btnYscia--/wgwlfxubofjokkrjcf0m.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-plush-apex-top-mattress",
  "name": "Beautyrest Black Series Four 16\" Hybrid Plush Apex Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4949,
  "compareAt": 6449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4949,
    "compareAt": 6449
   },
   "Full": {
    "price": 5229,
    "compareAt": 6799
   },
   "Queen": {
    "price": 5599,
    "compareAt": 7299
   },
   "King": {
    "price": 6599,
    "compareAt": 8599
   },
   "California King": {
    "price": 6599,
    "compareAt": 8599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
   "https://images.salsify.com/image/upload/s--eGWxXlvJ--/mnvt7aectkmsmasffqz0.jpg",
   "https://images.salsify.com/image/upload/s--4RqGAEMF--/huzutktgv00yqzyeokya.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-plush-apex-top-mattress-low-profile-set",
  "name": "Beautyrest Black Series Four 16\" Hybrid Plush Apex Top Mattress Low Profile Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 5119,
  "compareAt": 6649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 5119,
    "compareAt": 6649
   },
   "Full": {
    "price": 5449,
    "compareAt": 7099
   },
   "Queen": {
    "price": 5819,
    "compareAt": 7549
   },
   "King": {
    "price": 6939,
    "compareAt": 8999
   },
   "California King": {
    "price": 6939,
    "compareAt": 8999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
   "https://images.salsify.com/image/upload/s--eGWxXlvJ--/mnvt7aectkmsmasffqz0.jpg",
   "https://images.salsify.com/image/upload/s--4RqGAEMF--/huzutktgv00yqzyeokya.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-black-series-four-16-hybrid-plush-apex-top-mattress-set",
  "name": "Beautyrest Black Series Four 16\" Hybrid Plush Apex Top Mattress Set",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 5119,
  "compareAt": 6649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 5119,
    "compareAt": 6649
   },
   "Full": {
    "price": 5449,
    "compareAt": 7099
   },
   "Queen": {
    "price": 5819,
    "compareAt": 7549
   },
   "King": {
    "price": 6939,
    "compareAt": 8999
   },
   "California King": {
    "price": 6939,
    "compareAt": 8999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--YD1IXuKT--/pqqcomdslzwnj6avqsot.jpg",
   "https://images.salsify.com/image/upload/s--eGWxXlvJ--/mnvt7aectkmsmasffqz0.jpg",
   "https://images.salsify.com/image/upload/s--4RqGAEMF--/huzutktgv00yqzyeokya.jpg",
   "https://images.salsify.com/image/upload/s--CYK6jWk6--/waam8tkwtqxrylgbvwu0.jpg"
  ],
  "description": "Experience the best of both worlds with the reimagined Beautyrest Black Hybrid mattress-the latest advancement from the creators of the original Hybrid mattress. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-one-medium-mattress",
  "name": "Beautyrest Level One Medium Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 799,
  "compareAt": 1049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "12.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 799,
    "compareAt": 1049
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 849,
    "compareAt": 1099
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--azGFK4qM--/vwihebooiu8vn3tmputh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--azGFK4qM--/vwihebooiu8vn3tmputh.jpg",
   "https://images.salsify.com/image/upload/s--L7Kq8Gi1--/puocuzdyyzerajla1usg.jpg",
   "https://images.salsify.com/image/upload/s--bst6ekno--/dzvhemf85ldzq2iovg3e.jpg",
   "https://images.salsify.com/image/upload/s--wnX6ZmfJ--/iyxsqfux4uqd5avjimi6.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while Beautyrest ActiveResponse Memory Foam provides contouring comfort desgined to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-one-firm-mattress",
  "name": "Beautyrest Level One Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 799,
  "compareAt": 1049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 799,
    "compareAt": 1049
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 849,
    "compareAt": 1099
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--J6oFCVdb--/clhd7sajpp0ffde4rwtv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--J6oFCVdb--/clhd7sajpp0ffde4rwtv.jpg",
   "https://images.salsify.com/image/upload/s--ecFVi6g2--/u9jhhtxhzszibaxxnclk.jpg",
   "https://images.salsify.com/image/upload/s--4kU5pG4c--/ohz5hf1ipoxyut0z4nql.jpg",
   "https://images.salsify.com/image/upload/s--7BW89-0h--/rp8afmrhfyqzx0iqsrd7.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while Beautyrest ActiveResponse Memory Foam provides contouring comfort desgined to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-one-plush-mattress",
  "name": "Beautyrest Level One Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 799,
  "compareAt": 1049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 799,
    "compareAt": 1049
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 849,
    "compareAt": 1099
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--igoYCGyR--/qx9hhqsimcz0mhcz97yf.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--igoYCGyR--/qx9hhqsimcz0mhcz97yf.jpg",
   "https://images.salsify.com/image/upload/s--5N5f9RCI--/q6oy15aevdkmcdanwof9.jpg",
   "https://images.salsify.com/image/upload/s--WV9tSniF--/sr2taz9psai8viavwupe.jpg",
   "https://images.salsify.com/image/upload/s--KwTeqT_Q--/ko0vx2l1mrwqfxrocqsk.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while Beautyrest ActiveResponse Memory Foam provides contouring comfort desgined to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-one-medium-pillow-top-mattress",
  "name": "Beautyrest Level One Medium Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 899,
  "compareAt": 1149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 899,
    "compareAt": 1149
   },
   "Twin XL": {
    "price": 899,
    "compareAt": 1149
   },
   "Full": {
    "price": 949,
    "compareAt": 1249
   },
   "Queen": {
    "price": 999,
    "compareAt": 1299
   },
   "King": {
    "price": 1399,
    "compareAt": 1799
   },
   "California King": {
    "price": 1399,
    "compareAt": 1799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--clvXThd0--/rceimlbpyy6dz3lqmsqk.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--clvXThd0--/rceimlbpyy6dz3lqmsqk.jpg",
   "https://images.salsify.com/image/upload/s--WSjJz6cA--/rmja7hst2i4fmr0edyqm.jpg",
   "https://images.salsify.com/image/upload/s--DZqRJYjg--/gerfdlgjv3p7fmihtqer.jpg",
   "https://images.salsify.com/image/upload/s--A4H6lqCb--/vbiunbf0v4wezbihtxmx.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while Beautyrest ActiveResponse Memory Foam provides contouring comfort desgined to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-extra-firm-mattress",
  "name": "Beautyrest Level Two Extra Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "13.25\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 999,
    "compareAt": 1299
   },
   "Full": {
    "price": 1099,
    "compareAt": 1449
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1549
   },
   "King": {
    "price": 1599,
    "compareAt": 2099
   },
   "California King": {
    "price": 1599,
    "compareAt": 2099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--dNI9yZTc--/mpb59dn13afnsqii7rwi.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--dNI9yZTc--/mpb59dn13afnsqii7rwi.jpg",
   "https://images.salsify.com/image/upload/s--sUh8XRYy--/zkahwchk918skwuirl3u.jpg",
   "https://images.salsify.com/image/upload/s--N1UDhVc---/fqoim8wboq0vgrtwv96m.jpg",
   "https://images.salsify.com/image/upload/s--3z2vHRxQ--/gckttu4ssj6ob5wsptum.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while the Beautyrest ActiveResponse Memory Foam provides contouring comfort designed to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-medium-mattress",
  "name": "Beautyrest Level Two Medium Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 999,
    "compareAt": 1299
   },
   "Full": {
    "price": 1099,
    "compareAt": 1449
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1549
   },
   "King": {
    "price": 1599,
    "compareAt": 2099
   },
   "California King": {
    "price": 1599,
    "compareAt": 2099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--8flpfcoL--/zwll9qxesnlkx2beuhry.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--8flpfcoL--/zwll9qxesnlkx2beuhry.jpg",
   "https://images.salsify.com/image/upload/s--N98jvGgt--/d5dahyeioobitinwzl73.jpg",
   "https://images.salsify.com/image/upload/s--QLliMUn0--/lpsbxopyonng8p3kmone.jpg",
   "https://images.salsify.com/image/upload/s--mw20slUm--/w2qtdyc6uijxwybxsrrq.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while the Beautyrest ActiveResponse Memory Foam provides contouring comfort designed to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-plush-mattress",
  "name": "Beautyrest Level Two Plush Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 999,
    "compareAt": 1299
   },
   "Full": {
    "price": 1099,
    "compareAt": 1449
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1549
   },
   "King": {
    "price": 1599,
    "compareAt": 2099
   },
   "California King": {
    "price": 1599,
    "compareAt": 2099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Pj1Q2XeA--/m8m5qeka0zqg6mtcne85.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Pj1Q2XeA--/m8m5qeka0zqg6mtcne85.jpg",
   "https://images.salsify.com/image/upload/s--87x1DWbK--/sdszoxsmsskssptydnkl.jpg",
   "https://images.salsify.com/image/upload/s--MXmmCaF3--/zzwj3ffyjdvzezgftmao.jpg",
   "https://images.salsify.com/image/upload/s--6rv23JFi--/xy5ytcgmr1v5silllims.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while the Beautyrest ActiveResponse Memory Foam provides contouring comfort designed to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-medium-firm-pillow-top-mattress",
  "name": "Beautyrest Level Two Medium Firm Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "14.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1099,
    "compareAt": 1449
   },
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1199,
    "compareAt": 1549
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1699
   },
   "King": {
    "price": 1699,
    "compareAt": 2199
   },
   "California King": {
    "price": 1699,
    "compareAt": 2199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--S3A5ZSz2--/qhta5nzweru9ska4skyd.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--S3A5ZSz2--/qhta5nzweru9ska4skyd.jpg",
   "https://images.salsify.com/image/upload/s--GG7vmYDE--/krkhbgikmovqodhm600j.jpg",
   "https://images.salsify.com/image/upload/s--seXd-9DJ--/y4ilf5gwip6cnymp7u22.jpg",
   "https://images.salsify.com/image/upload/s--u3q14r5X--/krbjii3meuvyr9ipyukl.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while the Beautyrest ActiveResponse Memory Foam provides contouring comfort designed to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-plush-pillow-top-mattress",
  "name": "Beautyrest Level Two Plush Pillow Top Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14.75\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1099,
    "compareAt": 1449
   },
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1199,
    "compareAt": 1549
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1699
   },
   "King": {
    "price": 1699,
    "compareAt": 2199
   },
   "California King": {
    "price": 1699,
    "compareAt": 2199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BNI4DFaE--/mo3bus75xnjlumwvlhui.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BNI4DFaE--/mo3bus75xnjlumwvlhui.jpg",
   "https://images.salsify.com/image/upload/s--OmelkGLj--/o8taqeop495lnyyyd0ii.jpg",
   "https://images.salsify.com/image/upload/s--y3ePloNk--/mam55vpviqqzlraqa6qp.jpg",
   "https://images.salsify.com/image/upload/s--fmCxN9u5--/ziuibebrs6tr5ysd0n7q.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation, while the Beautyrest ActiveResponse Memory Foam provides contouring comfort designed to help alleviate aches and pains. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "beautyrest-level-two-hybrid-medium-firm-mattress",
  "name": "Beautyrest Level Two Hybrid Medium Firm Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "12\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1199,
    "compareAt": 1549
   },
   "Twin XL": {
    "price": 1199,
    "compareAt": 1549
   },
   "Full": {
    "price": 1299,
    "compareAt": 1699
   },
   "Queen": {
    "price": 1399,
    "compareAt": 1799
   },
   "King": {
    "price": 1799,
    "compareAt": 2349
   },
   "California King": {
    "price": 1799,
    "compareAt": 2349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--F2hacPTI--/ecubnia5flnfcp1iwnnq.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--F2hacPTI--/ecubnia5flnfcp1iwnnq.jpg",
   "https://images.salsify.com/image/upload/s--T49JnwLZ--/evpyklve9cz7u5hy9xqa.jpg",
   "https://images.salsify.com/image/upload/s--DutMLaaQ--/q6kie5jcox2z34bf0pvt.jpg",
   "https://images.salsify.com/image/upload/s--KnCfxMX9--/qzqz5gzis35znk1tagnv.jpg"
  ],
  "description": "There's sleep, and then there's Beautyrest. With the new Beautyrest mattress collection, 875-density Pocketed Coil Technology provides our signature individualized support + motion separation. Sleep comfortably with a cooling sleep surface provided by InfiniCool Technology. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-bluff-firm-hybrid-14-5-hybrid-firm-mattress",
  "name": "Serta Perfect Sleeper Cascade Bluff Firm Hybrid 14.5\" Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1199,
    "compareAt": 1549
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1699
   },
   "King": {
    "price": 1799,
    "compareAt": 2349
   },
   "California King": {
    "price": 1799,
    "compareAt": 2349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Xljwp8xA--/lchapnqfsjg8lqmr6ixj.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Xljwp8xA--/lchapnqfsjg8lqmr6ixj.jpg",
   "https://images.salsify.com/image/upload/s--7e9i42KQ--/qatbch3qppf8yahgjn4f.jpg",
   "https://images.salsify.com/image/upload/s--fm_Qcc6h--/y6sfn4entgx9czcybomc.jpg",
   "https://images.salsify.com/image/upload/s--P6QbM55C--/schbdwtodjwn5s6wpehx.jpg"
  ],
  "description": "Serta Perfect Sleeper Firm Hybrid 14.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-bluff-plush-hybrid-14-5-hybrid-plush-mattress",
  "name": "Serta Perfect Sleeper Cascade Bluff Plush Hybrid 14.5\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1199,
    "compareAt": 1549
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1699
   },
   "King": {
    "price": 1799,
    "compareAt": 2349
   },
   "California King": {
    "price": 1799,
    "compareAt": 2349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ZXsta4SL--/vdwxpnarytsjphlopyhm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ZXsta4SL--/vdwxpnarytsjphlopyhm.jpg",
   "https://images.salsify.com/image/upload/s--J_w_4YJK--/ztieuxhjfhvxhrgdyhbk.jpg",
   "https://images.salsify.com/image/upload/s--1izdHu-e--/sqabxsdlh5pidlidadqs.jpg",
   "https://images.salsify.com/image/upload/s--wdBexn7m--/xraz8cmj1xwgkzd9u4rk.jpg"
  ],
  "description": "Serta Perfect Sleeper Plush Hybrid 14.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-bluff-medium-hybrid-13-5-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper Cascade Bluff Medium Hybrid 13.5\" Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 999,
    "compareAt": 1299
   },
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1199,
    "compareAt": 1549
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1699
   },
   "King": {
    "price": 1799,
    "compareAt": 2349
   },
   "California King": {
    "price": 1799,
    "compareAt": 2349
   }
  },
  "image": "https://images.salsify.com/image/upload/s--4p9RgBSB--/h8kjl8dkrwmml6ohj11e.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--4p9RgBSB--/h8kjl8dkrwmml6ohj11e.jpg",
   "https://images.salsify.com/image/upload/s--flA1ZTtY--/qluc4jrci7sl5ck82g31.jpg",
   "https://images.salsify.com/image/upload/s--wG86kjpJ--/sljfmywtwkzcqao8i9cd.jpg",
   "https://images.salsify.com/image/upload/s--geT3OpEJ--/rjcrqa4ks3vjmqqoybsh.jpg"
  ],
  "description": "Serta Perfect Sleeper Medium Hybrid 13.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-ridge-plush-12-5-plush-mattress",
  "name": "Serta Perfect Sleeper Cascade Ridge Plush 12.5\" Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 649,
  "compareAt": 849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "12.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 649,
    "compareAt": 849
   },
   "Twin XL": {
    "price": 699,
    "compareAt": 899
   },
   "Full": {
    "price": 799,
    "compareAt": 1049
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--40mezflq--/hxp4wnfcqydrfxjigkgq.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--40mezflq--/hxp4wnfcqydrfxjigkgq.jpg",
   "https://images.salsify.com/image/upload/s--RJbs3dHx--/vglot0lzrzduvn1aauvw.jpg",
   "https://images.salsify.com/image/upload/s--tIJvbk4M--/mx2ovkxsv7sv3plbs8rt.jpg",
   "https://images.salsify.com/image/upload/s--rZ_yD5bf--/frjn61syfjxmtslprmll.jpg"
  ],
  "description": "Serta Perfect Sleeper Plush 12.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-range-extra-firm-14-extra-firm-mattress",
  "name": "Serta Perfect Sleeper Cascade Range Extra Firm 14\" Extra Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 749,
  "compareAt": 949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 749,
    "compareAt": 949
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 899,
    "compareAt": 1149
   },
   "Queen": {
    "price": 999,
    "compareAt": 1299
   },
   "King": {
    "price": 1399,
    "compareAt": 1799
   },
   "California King": {
    "price": 1399,
    "compareAt": 1799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QlGqlFTI--/dbynstyvd1qxxomunajl.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QlGqlFTI--/dbynstyvd1qxxomunajl.jpg",
   "https://images.salsify.com/image/upload/s--ggTnIp_y--/j7dxu80kojajfljszbvd.jpg",
   "https://images.salsify.com/image/upload/s--gCdTNr-H--/sdov2yhlrxp5s30rt0or.jpg",
   "https://images.salsify.com/image/upload/s--gVFHNu_w--/eu6hbkizhz2dd6t4dl56.jpg"
  ],
  "description": "Serta Perfect Sleeper Extra Firm 14\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-range-firm-pillow-top-14-5-firm-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Cascade Range Firm Pillow Top 14.5\" Firm Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 849,
  "compareAt": 1099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 849,
    "compareAt": 1099
   },
   "Twin XL": {
    "price": 899,
    "compareAt": 1149
   },
   "Full": {
    "price": 999,
    "compareAt": 1299
   },
   "Queen": {
    "price": 1099,
    "compareAt": 1449
   },
   "King": {
    "price": 1499,
    "compareAt": 1949
   },
   "California King": {
    "price": 1499,
    "compareAt": 1949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BdoPyOJI--/lace5wfz6b0tlxnutkgg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BdoPyOJI--/lace5wfz6b0tlxnutkgg.jpg",
   "https://images.salsify.com/image/upload/s--PAO3JyCL--/h0jgwwip3a8bad7pryw2.jpg",
   "https://images.salsify.com/image/upload/s--9vWP9WFG--/wtgnplf4zikwb0yrcr0k.jpg",
   "https://images.salsify.com/image/upload/s--ZYoYWCHn--/ks0bemzkuzpdr2vl6dyo.jpg"
  ],
  "description": "Serta Perfect Sleeper Firm Pillow Top 14.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-range-plush-pillow-top-15-plush-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Cascade Range Plush Pillow Top 15\" Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 849,
  "compareAt": 1099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 849,
    "compareAt": 1099
   },
   "Twin XL": {
    "price": 899,
    "compareAt": 1149
   },
   "Full": {
    "price": 999,
    "compareAt": 1299
   },
   "Queen": {
    "price": 1099,
    "compareAt": 1449
   },
   "King": {
    "price": 1499,
    "compareAt": 1949
   },
   "California King": {
    "price": 1499,
    "compareAt": 1949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Gfn9lI8V--/vjlpjc85ub2bgskg5ms1.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Gfn9lI8V--/vjlpjc85ub2bgskg5ms1.jpg",
   "https://images.salsify.com/image/upload/s--vZs-RpCJ--/zq8baljp9ozb17qlzdqv.jpg",
   "https://images.salsify.com/image/upload/s--8udzzCrF--/npvv3skgkyoztzwquh7a.jpg",
   "https://images.salsify.com/image/upload/s--CDs5q8uY--/rgqkqhlaegfnw6iciute.jpg"
  ],
  "description": "Serta Perfect Sleeper Plush 15\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-range-medium-14-medium-mattress",
  "name": "Serta Perfect Sleeper Cascade Range Medium 14\" Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 749,
  "compareAt": 949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 749,
    "compareAt": 949
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 899,
    "compareAt": 1149
   },
   "Queen": {
    "price": 999,
    "compareAt": 1299
   },
   "King": {
    "price": 1399,
    "compareAt": 1799
   },
   "California King": {
    "price": 1399,
    "compareAt": 1799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--bY8FWBzq--/sgbqyaftdi1js7bgy3vu.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--bY8FWBzq--/sgbqyaftdi1js7bgy3vu.jpg",
   "https://images.salsify.com/image/upload/s--T-IMPC4A--/fbpegikkvdgteffuatj2.jpg",
   "https://images.salsify.com/image/upload/s--xYbT-DhA--/cvpsg1cjbq3yrurbyn6g.jpg",
   "https://images.salsify.com/image/upload/s--4kT4ULiv--/mohlzqlah9ptpg2bdikz.jpg"
  ],
  "description": "Serta Perfect Sleeper Medium 14\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 920 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-canyon-plush-13-5-plush-mattress",
  "name": "Serta Perfect Sleeper Cascade Canyon Plush 13.5\" Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 649,
  "compareAt": 849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.5\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 649,
    "compareAt": 849
   },
   "Twin XL": {
    "price": 699,
    "compareAt": 899
   },
   "Full": {
    "price": 799,
    "compareAt": 1049
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--aH7FEUAr--/ipw0stthdv29fl1gkvgx.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--aH7FEUAr--/ipw0stthdv29fl1gkvgx.jpg",
   "https://images.salsify.com/image/upload/s--BKca-Pwk--/gindgqpvrr5wjsnlhc5n.jpg",
   "https://images.salsify.com/image/upload/s--Cufkfqee--/ru6kawxoiatdzrssz91n.jpg",
   "https://images.salsify.com/image/upload/s--nxRCzHfr--/xofpoyznsbk61rngbqit.jpg"
  ],
  "description": "Serta Perfect Sleeper Plush 13.5\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascase-canyon-medium-pillow-top-14-firm-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Cascase Canyon Medium Pillow Top 14\" Firm Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 749,
  "compareAt": 949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 749,
    "compareAt": 949
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 899,
    "compareAt": 1149
   },
   "Queen": {
    "price": 999,
    "compareAt": 1299
   },
   "King": {
    "price": 1399,
    "compareAt": 1799
   },
   "California King": {
    "price": 1399,
    "compareAt": 1799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--E7UK36UP--/gxfuprul81iukuerihx6.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--E7UK36UP--/gxfuprul81iukuerihx6.jpg",
   "https://images.salsify.com/image/upload/s--Kca5hL3M--/er1gsvmb40rlmhzws6di.jpg",
   "https://images.salsify.com/image/upload/s--NIbZKwBy--/ovgxaj6cxigvyzatobxl.jpg",
   "https://images.salsify.com/image/upload/s--KjHj-R_q--/m0hcstbuku8akg0ktxzg.jpg"
  ],
  "description": "Serta Perfect Sleeper Medium Pillow Top 14\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-canyon-plush-pillow-top-14-medium-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Cascade Canyon Plush Pillow Top 14\" Medium Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 749,
  "compareAt": 949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 749,
    "compareAt": 949
   },
   "Twin XL": {
    "price": 799,
    "compareAt": 1049
   },
   "Full": {
    "price": 899,
    "compareAt": 1149
   },
   "Queen": {
    "price": 999,
    "compareAt": 1299
   },
   "King": {
    "price": 1399,
    "compareAt": 1799
   },
   "California King": {
    "price": 1399,
    "compareAt": 1799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--aeW1o66S--/rsjvl4etfku8vv0kroof.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--aeW1o66S--/rsjvl4etfku8vv0kroof.jpg",
   "https://images.salsify.com/image/upload/s--y3Oqt8Yi--/pn1kkismccjedvxxh7ah.jpg",
   "https://images.salsify.com/image/upload/s--4kQNUXLz--/sjtl5tcqxa2boa4ttzd3.jpg",
   "https://images.salsify.com/image/upload/s--Skkoqzr2--/c06tsx85tuzlkqqzbttd.jpg"
  ],
  "description": "Serta Perfect Sleeper Plush Pillow Top 14\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-canyon-medium-13-medium-mattress",
  "name": "Serta Perfect Sleeper Cascade Canyon Medium 13\" Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 649,
  "compareAt": 849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 649,
    "compareAt": 849
   },
   "Twin XL": {
    "price": 699,
    "compareAt": 899
   },
   "Full": {
    "price": 799,
    "compareAt": 1049
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--z4PSviaI--/re86aakaktgcillbwncp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--z4PSviaI--/re86aakaktgcillbwncp.jpg",
   "https://images.salsify.com/image/upload/s--knL-N2fk--/xbn4cv6gd9wkfy7q9kqq.jpg",
   "https://images.salsify.com/image/upload/s--TqycUkj5--/azhhzjalflxizc7zgtx7.jpg",
   "https://images.salsify.com/image/upload/s--T5Gy7pQ3--/poevjxqkpbv2o1rlpjnp.jpg"
  ],
  "description": "Serta Perfect Sleeper Medium 13\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-cascade-canyon-firm-13-firm-mattress",
  "name": "Serta Perfect Sleeper Cascade Canyon Firm 13\" Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 649,
  "compareAt": 849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13\"",
  "type": "Innerspring",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 649,
    "compareAt": 849
   },
   "Twin XL": {
    "price": 699,
    "compareAt": 899
   },
   "Full": {
    "price": 799,
    "compareAt": 1049
   },
   "Queen": {
    "price": 899,
    "compareAt": 1149
   },
   "King": {
    "price": 1299,
    "compareAt": 1699
   },
   "California King": {
    "price": 1299,
    "compareAt": 1699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--da6tbRxR--/a3kxonm2ibrdezj4nkmr.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--da6tbRxR--/a3kxonm2ibrdezj4nkmr.jpg",
   "https://images.salsify.com/image/upload/s--tyOliee_--/q9ogs1wnktzenllj7n9z.jpg",
   "https://images.salsify.com/image/upload/s--wrV-yj6w--/kwkhyqmlgeuussiebbb1.jpg",
   "https://images.salsify.com/image/upload/s---ABwSsQi--/xdn97i9bi1hltcwvujo4.jpg"
  ],
  "description": "Serta Perfect Sleeper Firm 13\" delivers perfect sleep, night after night. Featuring our Q4 Support System, 860 density 4-in-1 coils that are perfectly linked for even weight distribution and long-lasting support with BestEdge Foam Encasement for stability. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-aspen-12-5-hybrid-firm-mattress",
  "name": "Serta Perfect Sleeper X Aspen 12.5\" Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "12.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1199,
    "compareAt": 1549
   },
   "Full": {
    "price": 1349,
    "compareAt": 1749
   },
   "Queen": {
    "price": 1499,
    "compareAt": 1949
   },
   "King": {
    "price": 2099,
    "compareAt": 2749
   },
   "California King": {
    "price": 2099,
    "compareAt": 2749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
   "https://images.salsify.com/image/upload/s--G42xr2wF--/q8iztkrzh6mqce2oy4pe.jpg",
   "https://images.salsify.com/image/upload/s--HwvQ7aKA--/rgchdscfpjyfx0l3asi3.jpg",
   "https://images.salsify.com/image/upload/s--71vqUfQa--/xr8ifahihri7vughrpyx.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-aspen-12-5-hybrid-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Aspen 12.5\" Hybrid Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "18.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1569,
    "compareAt": 2049
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2439,
    "compareAt": 3149
   },
   "California King": {
    "price": 2439,
    "compareAt": 3149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
   "https://images.salsify.com/image/upload/s--G42xr2wF--/q8iztkrzh6mqce2oy4pe.jpg",
   "https://images.salsify.com/image/upload/s--HwvQ7aKA--/rgchdscfpjyfx0l3asi3.jpg",
   "https://images.salsify.com/image/upload/s--71vqUfQa--/xr8ifahihri7vughrpyx.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-aspen-12-5-hybrid-firm-mattress-set",
  "name": "Serta Perfect Sleeper X Aspen 12.5\" Hybrid Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "21.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1569,
    "compareAt": 2049
   },
   "Queen": {
    "price": 1719,
    "compareAt": 2249
   },
   "King": {
    "price": 2439,
    "compareAt": 3149
   },
   "California King": {
    "price": 2439,
    "compareAt": 3149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DM-yqCQh--/yyg0rtqgxnya6dqy6hng.jpg",
   "https://images.salsify.com/image/upload/s--G42xr2wF--/q8iztkrzh6mqce2oy4pe.jpg",
   "https://images.salsify.com/image/upload/s--HwvQ7aKA--/rgchdscfpjyfx0l3asi3.jpg",
   "https://images.salsify.com/image/upload/s--71vqUfQa--/xr8ifahihri7vughrpyx.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-plush-mattress",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1399,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1399,
    "compareAt": 1799
   },
   "Full": {
    "price": 1549,
    "compareAt": 1999
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
   "https://images.salsify.com/image/upload/s--o7kaydcM--/vjfkdhahx9u2cfqysf6p.jpg",
   "https://images.salsify.com/image/upload/s--rdlYmdx9--/bhohs6jhjpydv3a4hgad.jpg",
   "https://images.salsify.com/image/upload/s--irBrWhUH--/jicfwpacc2atyotcxwrr.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-plush-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
   "https://images.salsify.com/image/upload/s--o7kaydcM--/vjfkdhahx9u2cfqysf6p.jpg",
   "https://images.salsify.com/image/upload/s--rdlYmdx9--/bhohs6jhjpydv3a4hgad.jpg",
   "https://images.salsify.com/image/upload/s--irBrWhUH--/jicfwpacc2atyotcxwrr.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-plush-mattress-set",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--eHQJsVPR--/d4uqqm6nocj4hhx5sz8e.jpg",
   "https://images.salsify.com/image/upload/s--o7kaydcM--/vjfkdhahx9u2cfqysf6p.jpg",
   "https://images.salsify.com/image/upload/s--rdlYmdx9--/bhohs6jhjpydv3a4hgad.jpg",
   "https://images.salsify.com/image/upload/s--irBrWhUH--/jicfwpacc2atyotcxwrr.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1399,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1399,
    "compareAt": 1799
   },
   "Full": {
    "price": 1549,
    "compareAt": 1999
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
   "https://images.salsify.com/image/upload/s--n_emhDAe--/kbz3lpp6eryfses4oox2.jpg",
   "https://images.salsify.com/image/upload/s--tnjbkad2--/ojnyplhmsz2fmiwkovjv.jpg",
   "https://images.salsify.com/image/upload/s--cNdvy5pq--/kswznyftyku5qjicrdz9.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-medium-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "19\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
   "https://images.salsify.com/image/upload/s--n_emhDAe--/kbz3lpp6eryfses4oox2.jpg",
   "https://images.salsify.com/image/upload/s--tnjbkad2--/ojnyplhmsz2fmiwkovjv.jpg",
   "https://images.salsify.com/image/upload/s--cNdvy5pq--/kswznyftyku5qjicrdz9.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-kendall-13-hybrid-medium-mattress-set",
  "name": "Serta Perfect Sleeper X Kendall 13\" Hybrid Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QLS5B8rs--/mak5xdjthrw5rilknwzy.jpg",
   "https://images.salsify.com/image/upload/s--n_emhDAe--/kbz3lpp6eryfses4oox2.jpg",
   "https://images.salsify.com/image/upload/s--tnjbkad2--/ojnyplhmsz2fmiwkovjv.jpg",
   "https://images.salsify.com/image/upload/s--cNdvy5pq--/kswznyftyku5qjicrdz9.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-plush-mattress",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
   "https://images.salsify.com/image/upload/s--X3XiiPzO--/quitik3dad44vanvryg7.jpg",
   "https://images.salsify.com/image/upload/s--EazUhe8y--/hebojmuqjcdc31twg1ud.jpg",
   "https://images.salsify.com/image/upload/s--okUWsjXE--/xdeg9wevcxyqvtf7d2jb.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-plush-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
   "https://images.salsify.com/image/upload/s--X3XiiPzO--/quitik3dad44vanvryg7.jpg",
   "https://images.salsify.com/image/upload/s--EazUhe8y--/hebojmuqjcdc31twg1ud.jpg",
   "https://images.salsify.com/image/upload/s--okUWsjXE--/xdeg9wevcxyqvtf7d2jb.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-plush-mattress-set",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SKhlD6ST--/qe5pmejjwnspvakhscav.jpg",
   "https://images.salsify.com/image/upload/s--X3XiiPzO--/quitik3dad44vanvryg7.jpg",
   "https://images.salsify.com/image/upload/s--EazUhe8y--/hebojmuqjcdc31twg1ud.jpg",
   "https://images.salsify.com/image/upload/s--okUWsjXE--/xdeg9wevcxyqvtf7d2jb.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-medium-firm-mattress",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Medium Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "14\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
   "https://images.salsify.com/image/upload/s--x6BDuTA---/ldrhkgmgmvqzjgmimwaj.jpg",
   "https://images.salsify.com/image/upload/s--kpQpoCVT--/stds4ro3ehhvnlrbqgpt.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-medium-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Medium Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "20\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
   "https://images.salsify.com/image/upload/s--x6BDuTA---/ldrhkgmgmvqzjgmimwaj.jpg",
   "https://images.salsify.com/image/upload/s--kpQpoCVT--/stds4ro3ehhvnlrbqgpt.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-prescott-14-hybrid-medium-firm-mattress-set",
  "name": "Serta Perfect Sleeper X Prescott 14\" Hybrid Medium Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1769,
  "compareAt": 2299,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium Firm",
  "height": "23\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1769,
    "compareAt": 2299
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2839,
    "compareAt": 3699
   },
   "California King": {
    "price": 2839,
    "compareAt": 3699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--nLX6P_2m--/pgyhxsexx1wppox1kup7.jpg",
   "https://images.salsify.com/image/upload/s--x6BDuTA---/ldrhkgmgmvqzjgmimwaj.jpg",
   "https://images.salsify.com/image/upload/s--kpQpoCVT--/stds4ro3ehhvnlrbqgpt.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience xtra premium support and xtra perfect sleep with our new Serta Perfect Sleeper X Collection. Our 5 ZoneActive Design promotes full-body spinal alignment for xtra support. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-75-hybrid-plush-mattress",
  "name": "Serta Perfect Sleeper X Knox 13.75\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1949,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
   "https://images.salsify.com/image/upload/s--ZEiRpCOy--/noybff2ad4f50nhjzqa4.jpg",
   "https://images.salsify.com/image/upload/s--Hg5CSVbA--/cziczvx0wdyu8wl7huhz.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-75-hybrid-plush-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Knox 13.75\" Hybrid Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
   "https://images.salsify.com/image/upload/s--ZEiRpCOy--/noybff2ad4f50nhjzqa4.jpg",
   "https://images.salsify.com/image/upload/s--Hg5CSVbA--/cziczvx0wdyu8wl7huhz.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-75-hybrid-plush-mattress-set",
  "name": "Serta Perfect Sleeper X Knox 13.75\" Hybrid Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--TUH7UAoD--/fraojfayoaqhtltib7wm.jpg",
   "https://images.salsify.com/image/upload/s--ZEiRpCOy--/noybff2ad4f50nhjzqa4.jpg",
   "https://images.salsify.com/image/upload/s--Hg5CSVbA--/cziczvx0wdyu8wl7huhz.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-5-hybrid-firm-mattress",
  "name": "Serta Perfect Sleeper X Knox 13.5\" Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1949,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
   "https://images.salsify.com/image/upload/s--DXKttSRX--/n3egzjvgzsylzuugpkyk.jpg",
   "https://images.salsify.com/image/upload/s--ObI7fpkK--/i4bpbqmhztxclqpdrxyr.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-5-hybrid-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Knox 13.5\" Hybrid Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
   "https://images.salsify.com/image/upload/s--DXKttSRX--/n3egzjvgzsylzuugpkyk.jpg",
   "https://images.salsify.com/image/upload/s--ObI7fpkK--/i4bpbqmhztxclqpdrxyr.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-knox-13-5-hybrid-firm-mattress-set",
  "name": "Serta Perfect Sleeper X Knox 13.5\" Hybrid Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qviXj6F8--/gbyyrtcycv8eiel0yxfs.jpg",
   "https://images.salsify.com/image/upload/s--DXKttSRX--/n3egzjvgzsylzuugpkyk.jpg",
   "https://images.salsify.com/image/upload/s--ObI7fpkK--/i4bpbqmhztxclqpdrxyr.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-lexton-14-25-hybrid-medium-pillow-top-mattress",
  "name": "Serta Perfect Sleeper X Lexton 14.25\" Hybrid Medium Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2299,
    "compareAt": 2999
   },
   "King": {
    "price": 2899,
    "compareAt": 3749
   },
   "California King": {
    "price": 2899,
    "compareAt": 3749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
   "https://images.salsify.com/image/upload/s--gQJSTz-S--/xwofrrej8chomkbcwn0e.jpg",
   "https://images.salsify.com/image/upload/s--kOPfbztp--/uqowy45rlll2itvsnz2j.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-lexton-14-25-hybrid-medium-pillow-top-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Lexton 14.25\" Hybrid Medium Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Full": {
    "price": 2369,
    "compareAt": 3099
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3239,
    "compareAt": 4199
   },
   "California King": {
    "price": 3239,
    "compareAt": 4199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
   "https://images.salsify.com/image/upload/s--gQJSTz-S--/xwofrrej8chomkbcwn0e.jpg",
   "https://images.salsify.com/image/upload/s--kOPfbztp--/uqowy45rlll2itvsnz2j.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-lexton-14-25-hybrid-medium-pillow-top-mattress-set",
  "name": "Serta Perfect Sleeper X Lexton 14.25\" Hybrid Medium Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Full": {
    "price": 2369,
    "compareAt": 3099
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3239,
    "compareAt": 4199
   },
   "California King": {
    "price": 3239,
    "compareAt": 4199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--csSJ2pcZ--/rmaxcy1pxldec5qdvp8y.jpg",
   "https://images.salsify.com/image/upload/s--gQJSTz-S--/xwofrrej8chomkbcwn0e.jpg",
   "https://images.salsify.com/image/upload/s--kOPfbztp--/uqowy45rlll2itvsnz2j.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-14-25-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper X Max 14.25\" Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Full": {
    "price": 2149,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2299,
    "compareAt": 2999
   },
   "King": {
    "price": 2899,
    "compareAt": 3749
   },
   "California King": {
    "price": 2899,
    "compareAt": 3749
   }
  },
  "image": "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
   "https://images.salsify.com/image/upload/s--TEMCQLnx--/g36b8pmfzfcdofuhjw9e.jpg",
   "https://images.salsify.com/image/upload/s--OEdO8vAf--/dvlb8vsyk2a6ij6h2isv.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-14-25-hybrid-medium-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Max 14.25\" Hybrid Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Full": {
    "price": 2369,
    "compareAt": 3099
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3239,
    "compareAt": 4199
   },
   "California King": {
    "price": 3239,
    "compareAt": 4199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
   "https://images.salsify.com/image/upload/s--TEMCQLnx--/g36b8pmfzfcdofuhjw9e.jpg",
   "https://images.salsify.com/image/upload/s--OEdO8vAf--/dvlb8vsyk2a6ij6h2isv.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-14-25-hybrid-medium-mattress-set",
  "name": "Serta Perfect Sleeper X Max 14.25\" Hybrid Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Full": {
    "price": 2369,
    "compareAt": 3099
   },
   "Queen": {
    "price": 2519,
    "compareAt": 3249
   },
   "King": {
    "price": 3239,
    "compareAt": 4199
   },
   "California King": {
    "price": 3239,
    "compareAt": 4199
   }
  },
  "image": "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--49zO9AJA--/rpegglqbzdduc684qmib.jpg",
   "https://images.salsify.com/image/upload/s--TEMCQLnx--/g36b8pmfzfcdofuhjw9e.jpg",
   "https://images.salsify.com/image/upload/s--OEdO8vAf--/dvlb8vsyk2a6ij6h2isv.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-hybrid-plush-pillow-top-mattress",
  "name": "Serta Perfect Sleeper X Max 15\" Hybrid Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2199,
  "compareAt": 2849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2199,
    "compareAt": 2849
   },
   "Full": {
    "price": 2349,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
   "https://images.salsify.com/image/upload/s--3lid2EXr--/nru7fprjn1kniusr6hxd.jpg",
   "https://images.salsify.com/image/upload/s--OFTSerl5--/cuhfhnhowjli7yz3pyj7.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-hybrid-plush-pillow-top-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Max 15\" Hybrid Plush Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2369,
  "compareAt": 3099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2369,
    "compareAt": 3099
   },
   "Full": {
    "price": 2569,
    "compareAt": 3349
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
   "https://images.salsify.com/image/upload/s--3lid2EXr--/nru7fprjn1kniusr6hxd.jpg",
   "https://images.salsify.com/image/upload/s--OFTSerl5--/cuhfhnhowjli7yz3pyj7.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-hybrid-plush-pillow-top-mattress-set",
  "name": "Serta Perfect Sleeper X Max 15\" Hybrid Plush Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2369,
  "compareAt": 3099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2369,
    "compareAt": 3099
   },
   "Full": {
    "price": 2569,
    "compareAt": 3349
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--SgRcdY8n--/nvps1k1lakjhiyuzcbcr.jpg",
   "https://images.salsify.com/image/upload/s--3lid2EXr--/nru7fprjn1kniusr6hxd.jpg",
   "https://images.salsify.com/image/upload/s--OFTSerl5--/cuhfhnhowjli7yz3pyj7.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-25-hybrid-firm-pillow-top-mattress",
  "name": "Serta Perfect Sleeper X Max 15.25\" Hybrid Firm Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2199,
  "compareAt": 2849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "15.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2199,
    "compareAt": 2849
   },
   "Full": {
    "price": 2349,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
   "https://images.salsify.com/image/upload/s--Gcbm9Qqj--/lrql45ml8zgonbprbztc.jpg",
   "https://images.salsify.com/image/upload/s--WFW5I8CC--/uxbcweuovbgbkwrnf8ph.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-25-hybrid-firm-pillow-top-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Max 15.25\" Hybrid Firm Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2369,
  "compareAt": 3099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "21.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2369,
    "compareAt": 3099
   },
   "Full": {
    "price": 2569,
    "compareAt": 3349
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
   "https://images.salsify.com/image/upload/s--Gcbm9Qqj--/lrql45ml8zgonbprbztc.jpg",
   "https://images.salsify.com/image/upload/s--WFW5I8CC--/uxbcweuovbgbkwrnf8ph.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-max-15-25-hybrid-firm-pillow-top-mattress-set",
  "name": "Serta Perfect Sleeper X Max 15.25\" Hybrid Firm Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2369,
  "compareAt": 3099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "24.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2369,
    "compareAt": 3099
   },
   "Full": {
    "price": 2569,
    "compareAt": 3349
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3439,
    "compareAt": 4449
   },
   "California King": {
    "price": 3439,
    "compareAt": 4449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--yPMhYHXt--/ajsdpydmbxiuxbsatvwh.jpg",
   "https://images.salsify.com/image/upload/s--Gcbm9Qqj--/lrql45ml8zgonbprbztc.jpg",
   "https://images.salsify.com/image/upload/s--WFW5I8CC--/uxbcweuovbgbkwrnf8ph.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-14-25-hybrid-plush-mattress",
  "name": "Serta Perfect Sleeper X Excelled 14.25\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1949,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
   "https://images.salsify.com/image/upload/s--3Zxg57gk--/hiughn9ycvyvkvutgqfr.jpg",
   "https://images.salsify.com/image/upload/s--CzD99HjZ--/vdkcwlv9jdljhjbgggqb.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-14-25-hybrid-plush-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Excelled 14.25\" Hybrid Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
   "https://images.salsify.com/image/upload/s--3Zxg57gk--/hiughn9ycvyvkvutgqfr.jpg",
   "https://images.salsify.com/image/upload/s--CzD99HjZ--/vdkcwlv9jdljhjbgggqb.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-14-25-hybrid-plush-mattress-set",
  "name": "Serta Perfect Sleeper X Excelled 14.25\" Hybrid Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23.25\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ANK4DzgY--/l3wir44lfkgspzyul1mh.jpg",
   "https://images.salsify.com/image/upload/s--3Zxg57gk--/hiughn9ycvyvkvutgqfr.jpg",
   "https://images.salsify.com/image/upload/s--CzD99HjZ--/vdkcwlv9jdljhjbgggqb.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-13-75-hybrid-extra-firm-mattress",
  "name": "Serta Perfect Sleeper X Excelled 13.75\" Hybrid Extra Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1799,
  "compareAt": 2349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "13.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1799,
    "compareAt": 2349
   },
   "Full": {
    "price": 1949,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2099,
    "compareAt": 2749
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
   "https://images.salsify.com/image/upload/s--kEX9Nni4--/yl77jrdtlvwfhzsg3gsv.jpg",
   "https://images.salsify.com/image/upload/s--wL1bfH48--/cnqdixyk592caocxy732.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-13-75-hybrid-extra-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper X Excelled 13.75\" Hybrid Extra Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "19.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
   "https://images.salsify.com/image/upload/s--kEX9Nni4--/yl77jrdtlvwfhzsg3gsv.jpg",
   "https://images.salsify.com/image/upload/s--wL1bfH48--/cnqdixyk592caocxy732.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-x-excelled-13-75-hybrid-extra-firm-mattress-set",
  "name": "Serta Perfect Sleeper X Excelled 13.75\" Hybrid Extra Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1969,
  "compareAt": 2549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "22.75\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1969,
    "compareAt": 2549
   },
   "Full": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2319,
    "compareAt": 2999
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rDE8eDfk--/bjdq9ytg0kuplqqmbzvs.jpg",
   "https://images.salsify.com/image/upload/s--kEX9Nni4--/yl77jrdtlvwfhzsg3gsv.jpg",
   "https://images.salsify.com/image/upload/s--wL1bfH48--/cnqdixyk592caocxy732.jpg",
   "https://images.salsify.com/image/upload/s--VbT0knto--/ac5kbwgfsqvgcqmpv9k2.jpg"
  ],
  "description": "Experience premium support and perfect sleep with our new Serta Quilted Perfect Sleeper X Collection. Our 5 ZoneResponse Design is comprised of Perfect Conform Memory Foam paired with 5-zoned coils for full-body alignment. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-hampton-12-5-latex-hybrid-extra-firm-mattress",
  "name": "Serta Perfect Sleeper Pro Hampton 12.5\" Latex Hybrid Extra Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "12.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
   "https://images.salsify.com/image/upload/s--zk-0aOm8--/gwimqvjhnizo4tn4swfc.jpg",
   "https://images.salsify.com/image/upload/s--Xy6yhsyb--/uicgcdu6kw9dejlxrpnb.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5 support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-hampton-12-5-latex-hybrid-extra-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Hampton 12.5\" Latex Hybrid Extra Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "18.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
   "https://images.salsify.com/image/upload/s--zk-0aOm8--/gwimqvjhnizo4tn4swfc.jpg",
   "https://images.salsify.com/image/upload/s--Xy6yhsyb--/uicgcdu6kw9dejlxrpnb.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5 support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-hampton-12-5-latex-hybrid-extra-firm-mattress-set",
  "name": "Serta Perfect Sleeper Pro Hampton 12.5\" Latex Hybrid Extra Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "21.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DBZwLuXS--/ww5kxi9tw4jb2awbv1z5.jpg",
   "https://images.salsify.com/image/upload/s--zk-0aOm8--/gwimqvjhnizo4tn4swfc.jpg",
   "https://images.salsify.com/image/upload/s--Xy6yhsyb--/uicgcdu6kw9dejlxrpnb.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5 support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-geneva-13-5-latex-hybrid-firm-mattress",
  "name": "Serta Perfect Sleeper Pro Geneva 13.5\" Latex Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
   "https://images.salsify.com/image/upload/s--iuA-9G6M--/aajt7unmtu9milagn6gj.jpg",
   "https://images.salsify.com/image/upload/s--JyJ-wQLa--/gueczkj3xctvsorjr1y4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-geneva-13-5-latex-hybrid-firm-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Geneva 13.5\" Latex Hybrid Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
   "https://images.salsify.com/image/upload/s--iuA-9G6M--/aajt7unmtu9milagn6gj.jpg",
   "https://images.salsify.com/image/upload/s--JyJ-wQLa--/gueczkj3xctvsorjr1y4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-geneva-13-5-latex-hybrid-firm-mattress-set",
  "name": "Serta Perfect Sleeper Pro Geneva 13.5\" Latex Hybrid Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22.5\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--lTV9ON0m--/ynvlqpnacy0irjt2tecy.jpg",
   "https://images.salsify.com/image/upload/s--iuA-9G6M--/aajt7unmtu9milagn6gj.jpg",
   "https://images.salsify.com/image/upload/s--JyJ-wQLa--/gueczkj3xctvsorjr1y4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-dublin-14-latex-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper Pro Dublin 14\" Latex Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
   "https://images.salsify.com/image/upload/s--7Gh47G4u--/jll6ms06vlam9r1iihpc.jpg",
   "https://images.salsify.com/image/upload/s--SZwdEI1E--/kmf6llopclyuhshkkyh4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-dublin-14-latex-hybrid-medium-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Dublin 14\" Latex Hybrid Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
   "https://images.salsify.com/image/upload/s--7Gh47G4u--/jll6ms06vlam9r1iihpc.jpg",
   "https://images.salsify.com/image/upload/s--SZwdEI1E--/kmf6llopclyuhshkkyh4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-dublin-14-latex-hybrid-medium-mattress-set",
  "name": "Serta Perfect Sleeper Pro Dublin 14\" Latex Hybrid Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--5O042TEM--/ivgl823woujemeclmpws.jpg",
   "https://images.salsify.com/image/upload/s--7Gh47G4u--/jll6ms06vlam9r1iihpc.jpg",
   "https://images.salsify.com/image/upload/s--SZwdEI1E--/kmf6llopclyuhshkkyh4.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-kensington-13-latex-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper Pro Kensington 13\" Latex Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
   "https://images.salsify.com/image/upload/s--75I2bsQq--/kcomlkjob90nfgq8lelh.jpg",
   "https://images.salsify.com/image/upload/s--mrdZv7XN--/psak1qjovutougorpv40.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-kensington-13-latex-hybrid-medium-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Kensington 13\" Latex Hybrid Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "19\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
   "https://images.salsify.com/image/upload/s--75I2bsQq--/kcomlkjob90nfgq8lelh.jpg",
   "https://images.salsify.com/image/upload/s--mrdZv7XN--/psak1qjovutougorpv40.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-kensington-13-latex-hybrid-medium-mattress-set",
  "name": "Serta Perfect Sleeper Pro Kensington 13\" Latex Hybrid Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--rzEcxM9j--/jfttuepfmsdrqfekkecw.jpg",
   "https://images.salsify.com/image/upload/s--75I2bsQq--/kcomlkjob90nfgq8lelh.jpg",
   "https://images.salsify.com/image/upload/s--mrdZv7XN--/psak1qjovutougorpv40.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 2\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-valais-15-latex-hybrid-plush-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Pro Valais 15\" Latex Hybrid Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2999,
    "compareAt": 3899
   },
   "Queen": {
    "price": 3499,
    "compareAt": 4549
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
   "https://images.salsify.com/image/upload/s--Emf6wZN9--/rv8aw6rf9zvvtvrzgwoe.jpg",
   "https://images.salsify.com/image/upload/s--wTwffLAl--/ck1uj7patjrwwz9rxyug.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-valais-15-latex-hybrid-plush-pillow-top-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Valais 15\" Latex Hybrid Plush Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
   "https://images.salsify.com/image/upload/s--Emf6wZN9--/rv8aw6rf9zvvtvrzgwoe.jpg",
   "https://images.salsify.com/image/upload/s--wTwffLAl--/ck1uj7patjrwwz9rxyug.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-valais-15-latex-hybrid-plush-pillow-top-mattress-set",
  "name": "Serta Perfect Sleeper Pro Valais 15\" Latex Hybrid Plush Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BW3I82-V--/gyjsisg4yixd7lzuiami.jpg",
   "https://images.salsify.com/image/upload/s--Emf6wZN9--/rv8aw6rf9zvvtvrzgwoe.jpg",
   "https://images.salsify.com/image/upload/s--wTwffLAl--/ck1uj7patjrwwz9rxyug.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-edinburgh-15-latex-hybrid-plush-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Pro Edinburgh 15\" Latex Hybrid Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2999,
    "compareAt": 3899
   },
   "Queen": {
    "price": 3499,
    "compareAt": 4549
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
   "https://images.salsify.com/image/upload/s--fFtWx5tu--/xf6p04kl5qjlddtfo9ua.jpg",
   "https://images.salsify.com/image/upload/s--_fMvdS_2--/ai95brqddblauj9w4dvk.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-edinburgh-15-latex-hybrid-plush-pillow-top-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro Edinburgh 15\" Latex Hybrid Plush Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
   "https://images.salsify.com/image/upload/s--fFtWx5tu--/xf6p04kl5qjlddtfo9ua.jpg",
   "https://images.salsify.com/image/upload/s--_fMvdS_2--/ai95brqddblauj9w4dvk.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-edinburgh-15-latex-hybrid-plush-pillow-top-mattress-set",
  "name": "Serta Perfect Sleeper Pro Edinburgh 15\" Latex Hybrid Plush Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--DmNv610m--/afidcrocbojwl141luxa.jpg",
   "https://images.salsify.com/image/upload/s--fFtWx5tu--/xf6p04kl5qjlddtfo9ua.jpg",
   "https://images.salsify.com/image/upload/s--_fMvdS_2--/ai95brqddblauj9w4dvk.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 3\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-new-paris-15-latex-hybrid-medium-mattress",
  "name": "Serta Perfect Sleeper Pro New Paris 15\" Latex Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2999,
    "compareAt": 3899
   },
   "Queen": {
    "price": 3499,
    "compareAt": 4549
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
   "https://images.salsify.com/image/upload/s--nYFhXHru--/lqc3jj8hs4chhfjvdkzp.jpg",
   "https://images.salsify.com/image/upload/s--I2fIsx9m--/b0gpcbfy4ihyggoyzypq.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-new-paris-15-latex-hybrid-medium-mattress-low-profile-set",
  "name": "Serta Perfect Sleeper Pro New Paris 15\" Latex Hybrid Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
   "https://images.salsify.com/image/upload/s--nYFhXHru--/lqc3jj8hs4chhfjvdkzp.jpg",
   "https://images.salsify.com/image/upload/s--I2fIsx9m--/b0gpcbfy4ihyggoyzypq.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-perfect-sleeper-pro-new-paris-15-latex-hybrid-medium-mattress-set",
  "name": "Serta Perfect Sleeper Pro New Paris 15\" Latex Hybrid Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "24\"",
  "type": "Latex Hybrid",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--P9322lT8--/xugrcnnt1rwqwhpqffj2.jpg",
   "https://images.salsify.com/image/upload/s--nYFhXHru--/lqc3jj8hs4chhfjvdkzp.jpg",
   "https://images.salsify.com/image/upload/s--I2fIsx9m--/b0gpcbfy4ihyggoyzypq.jpg",
   "https://images.salsify.com/image/upload/s--w5zTgKXm--/o4cayeahydv7ih4e6kfn.jpg"
  ],
  "description": "The new Serta Perfect Sleeper Pro, our most advanced hybrid mattress, features 5support zones designed with responsive coils and 4\" of naturally-derived latex* foam that retains its shape to improve spinal alignment, for the ultimate in targeted pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-medium-mattress",
  "name": "Serta iComfort Aveda 12\" Memory Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1449,
    "compareAt": 1899
   },
   "Queen": {
    "price": 1599,
    "compareAt": 2099
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
   "https://images.salsify.com/image/upload/s--aoMKcbTH--/feoms9fwwalmjelytusk.jpg",
   "https://images.salsify.com/image/upload/s--_tKYs0Xo--/ztgois6kr8lq3u3xuoco.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-medium-low-profile-mattress-set",
  "name": "Serta iComfort Aveda 12\" Memory Foam Medium Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "18\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
   "https://images.salsify.com/image/upload/s--aoMKcbTH--/feoms9fwwalmjelytusk.jpg",
   "https://images.salsify.com/image/upload/s--_tKYs0Xo--/ztgois6kr8lq3u3xuoco.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-medium-mattress-set",
  "name": "Serta iComfort Aveda 12\" Memory Foam Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--GOt37fAq--/af2e5868686317ee3cb395a4cb7cbd484c7dc9b3.jpg",
   "https://images.salsify.com/image/upload/s--aoMKcbTH--/feoms9fwwalmjelytusk.jpg",
   "https://images.salsify.com/image/upload/s--_tKYs0Xo--/ztgois6kr8lq3u3xuoco.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-plush-mattress",
  "name": "Serta iComfort Aveda 12\" Memory Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1449,
    "compareAt": 1899
   },
   "Queen": {
    "price": 1599,
    "compareAt": 2099
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
   "https://images.salsify.com/image/upload/s--DsO78QKP--/byb0wapcumzrroeoxksq.jpg",
   "https://images.salsify.com/image/upload/s--5bo9USgL--/xuecmzuvkqq5jjhoqpbv.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-plush-low-profile-mattress-set",
  "name": "Serta iComfort Aveda 12\" Memory Foam Plush Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "18\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
   "https://images.salsify.com/image/upload/s--DsO78QKP--/byb0wapcumzrroeoxksq.jpg",
   "https://images.salsify.com/image/upload/s--5bo9USgL--/xuecmzuvkqq5jjhoqpbv.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aveda-12-memory-foam-plush-mattress-set",
  "name": "Serta iComfort Aveda 12\" Memory Foam Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--R1ber9zM--/b3eooqshxwrzl1vgkepo.jpg",
   "https://images.salsify.com/image/upload/s--DsO78QKP--/byb0wapcumzrroeoxksq.jpg",
   "https://images.salsify.com/image/upload/s--5bo9USgL--/xuecmzuvkqq5jjhoqpbv.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-medium-mattress",
  "name": "Serta iComfort Aspire 14\" Memory Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1399,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "14\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1399,
    "compareAt": 1799
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2599,
    "compareAt": 3399
   },
   "California King": {
    "price": 2599,
    "compareAt": 3399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
   "https://images.salsify.com/image/upload/s--uGcaj6Zb--/za2ptjkcbp0chlchnehj.jpg",
   "https://images.salsify.com/image/upload/s--szXqVAoo--/xsojivgha3cn0pkserig.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-medium-low-profile-mattress-set",
  "name": "Serta iComfort Aspire 14\" Memory Foam Medium Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "20\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
   "https://images.salsify.com/image/upload/s--uGcaj6Zb--/za2ptjkcbp0chlchnehj.jpg",
   "https://images.salsify.com/image/upload/s--szXqVAoo--/xsojivgha3cn0pkserig.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-medium-mattress-set",
  "name": "Serta iComfort Aspire 14\" Memory Foam Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "23\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--QHKFqFkL--/py8ejtwczk76ih1ats4g.jpg",
   "https://images.salsify.com/image/upload/s--uGcaj6Zb--/za2ptjkcbp0chlchnehj.jpg",
   "https://images.salsify.com/image/upload/s--szXqVAoo--/xsojivgha3cn0pkserig.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-medium-mattress",
  "name": "Serta iComfort Iona 13\" Memory Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1199,
    "compareAt": 1549
   },
   "Full": {
    "price": 1549,
    "compareAt": 1999
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2399,
    "compareAt": 3099
   },
   "California King": {
    "price": 2399,
    "compareAt": 3099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
   "https://images.salsify.com/image/upload/s--dqUGR6Q9--/aofzbxjqhubwko4l7eaz.jpg",
   "https://images.salsify.com/image/upload/s--SC4_O_XS--/ln2rptbs2wosng9u3yot.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-medium-low-profile-mattress-set",
  "name": "Serta iComfort Iona 13\" Memory Foam Medium Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "19\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2739,
    "compareAt": 3549
   },
   "California King": {
    "price": 2739,
    "compareAt": 3549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
   "https://images.salsify.com/image/upload/s--dqUGR6Q9--/aofzbxjqhubwko4l7eaz.jpg",
   "https://images.salsify.com/image/upload/s--SC4_O_XS--/ln2rptbs2wosng9u3yot.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-medium-mattress-set",
  "name": "Serta iComfort Iona 13\" Memory Foam Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "22\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2739,
    "compareAt": 3549
   },
   "California King": {
    "price": 2739,
    "compareAt": 3549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vQ4ysLN2--/azcqkwjlirbf0gw1lwyo.jpg",
   "https://images.salsify.com/image/upload/s--dqUGR6Q9--/aofzbxjqhubwko4l7eaz.jpg",
   "https://images.salsify.com/image/upload/s--SC4_O_XS--/ln2rptbs2wosng9u3yot.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-plush-mattress",
  "name": "Serta iComfort Iona 13\" Memory Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1549,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1199,
    "compareAt": 1549
   },
   "Full": {
    "price": 1549,
    "compareAt": 1999
   },
   "Queen": {
    "price": 1699,
    "compareAt": 2199
   },
   "King": {
    "price": 2399,
    "compareAt": 3099
   },
   "California King": {
    "price": 2399,
    "compareAt": 3099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
   "https://images.salsify.com/image/upload/s--l2Dfx01M--/pr81eyryd2wk4mac01gr.jpg",
   "https://images.salsify.com/image/upload/s--Y11YcNPj--/tsanm9afm647qppwqrjr.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-plush-low-profile-mattress-set",
  "name": "Serta iComfort Iona 13\" Memory Foam Plush Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2739,
    "compareAt": 3549
   },
   "California King": {
    "price": 2739,
    "compareAt": 3549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
   "https://images.salsify.com/image/upload/s--l2Dfx01M--/pr81eyryd2wk4mac01gr.jpg",
   "https://images.salsify.com/image/upload/s--Y11YcNPj--/tsanm9afm647qppwqrjr.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-iona-13-memory-foam-plush-mattress-set",
  "name": "Serta iComfort Iona 13\" Memory Foam Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1369,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1369,
    "compareAt": 1799
   },
   "Full": {
    "price": 1769,
    "compareAt": 2299
   },
   "Queen": {
    "price": 1919,
    "compareAt": 2499
   },
   "King": {
    "price": 2739,
    "compareAt": 3549
   },
   "California King": {
    "price": 2739,
    "compareAt": 3549
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Cm_eQk5I--/vsadug5xcwkrzwslgzfl.jpg",
   "https://images.salsify.com/image/upload/s--l2Dfx01M--/pr81eyryd2wk4mac01gr.jpg",
   "https://images.salsify.com/image/upload/s--Y11YcNPj--/tsanm9afm647qppwqrjr.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-elana-11-5-memory-foam-firm-mattress",
  "name": "Serta iComfort Elana 11.5\" Memory Foam Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "11.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1099,
    "compareAt": 1449
   },
   "Full": {
    "price": 1449,
    "compareAt": 1899
   },
   "Queen": {
    "price": 1599,
    "compareAt": 2099
   },
   "King": {
    "price": 2299,
    "compareAt": 2999
   },
   "California King": {
    "price": 2299,
    "compareAt": 2999
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
   "https://images.salsify.com/image/upload/s--lh1VbZeY--/cw3a1viajtfgna8kkwms.jpg",
   "https://images.salsify.com/image/upload/s--v1tpplWm--/vo2dqxbnmeazus9y9sb5.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-elana-11-5-memory-foam-firm-low-profile-mattress-set",
  "name": "Serta iComfort Elana 11.5\" Memory Foam Firm Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "17.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
   "https://images.salsify.com/image/upload/s--lh1VbZeY--/cw3a1viajtfgna8kkwms.jpg",
   "https://images.salsify.com/image/upload/s--v1tpplWm--/vo2dqxbnmeazus9y9sb5.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-elana-11-5-memory-foam-firm-mattress-set",
  "name": "Serta iComfort Elana 11.5\" Memory Foam Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1269,
  "compareAt": 1649,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "20.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1269,
    "compareAt": 1649
   },
   "Full": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 1819,
    "compareAt": 2349
   },
   "King": {
    "price": 2639,
    "compareAt": 3449
   },
   "California King": {
    "price": 2639,
    "compareAt": 3449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ucXN9iBO--/jg9milc8946me5cyzjgp.jpg",
   "https://images.salsify.com/image/upload/s--lh1VbZeY--/cw3a1viajtfgna8kkwms.jpg",
   "https://images.salsify.com/image/upload/s--v1tpplWm--/vo2dqxbnmeazus9y9sb5.jpg",
   "https://images.salsify.com/image/upload/s--lMOyDbra--/hmcwqs0ueqnznjrxogce.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-plush-mattress",
  "name": "Serta iComfort Aspire 14\" Memory Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1399,
  "compareAt": 1799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1399,
    "compareAt": 1799
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2599,
    "compareAt": 3399
   },
   "California King": {
    "price": 2599,
    "compareAt": 3399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
   "https://images.salsify.com/image/upload/s--D5Jn2NxR--/sxfpzxxpvgnpm2llmcq3.jpg",
   "https://images.salsify.com/image/upload/s--WEqAjxiH--/rzc9snhfssumsugw0s3u.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-plush-low-profile-mattress-set",
  "name": "Serta iComfort Aspire 14\" Memory Foam Plush Low Profile Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "20\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
   "https://images.salsify.com/image/upload/s--D5Jn2NxR--/sxfpzxxpvgnpm2llmcq3.jpg",
   "https://images.salsify.com/image/upload/s--WEqAjxiH--/rzc9snhfssumsugw0s3u.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfort-aspire-14-memory-foam-plush-mattress-set",
  "name": "Serta iComfort Aspire 14\" Memory Foam Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1569,
  "compareAt": 2049,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "23\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1569,
    "compareAt": 2049
   },
   "Full": {
    "price": 1969,
    "compareAt": 2549
   },
   "Queen": {
    "price": 2119,
    "compareAt": 2749
   },
   "King": {
    "price": 2939,
    "compareAt": 3799
   },
   "California King": {
    "price": 2939,
    "compareAt": 3799
   }
  },
  "image": "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--vZF4I5nv--/n4ous0qapgyyo6qagi5x.jpg",
   "https://images.salsify.com/image/upload/s--D5Jn2NxR--/sxfpzxxpvgnpm2llmcq3.jpg",
   "https://images.salsify.com/image/upload/s--WEqAjxiH--/rzc9snhfssumsugw0s3u.jpg",
   "https://images.salsify.com/image/upload/s--pzVlXLK7--/q7usg76rr4ojgfrm8gaw.jpg"
  ],
  "description": "Serta iComfort Memory Foam features zoned support from memory foam layers for contouring pressure-relief and breathability. With alternating levels of firmness, ergonomically design support zones in every Serta mattress are designed to keep your body aligned as you sleep. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-buckingham-16-latex-foam-plush-pillow-top-mattress",
  "name": "Serta iComfortPro Buckingham 16\" Latex Foam Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 4699,
  "compareAt": 6099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "16\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4699,
    "compareAt": 6099
   },
   "Queen": {
    "price": 5199,
    "compareAt": 6749
   },
   "King": {
    "price": 5899,
    "compareAt": 7649
   },
   "California King": {
    "price": 5899,
    "compareAt": 7649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
   "https://images.salsify.com/image/upload/s--JVGi7A4T--/hax9auhakt95rjhuxqoh.jpg",
   "https://images.salsify.com/image/upload/s--dzijPu7p--/g2dso9exv50la30jpjat.jpg",
   "https://images.salsify.com/image/upload/s--AEd_7zlQ--/buzzvtityhtni2vzeegb.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-buckingham-16-latex-foam-plush-pillow-top-mattress-low-profile-set",
  "name": "Serta iComfortPro Buckingham 16\" Latex Foam Plush Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 4869,
  "compareAt": 6349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4869,
    "compareAt": 6349
   },
   "Queen": {
    "price": 5419,
    "compareAt": 7049
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
   "https://images.salsify.com/image/upload/s--JVGi7A4T--/hax9auhakt95rjhuxqoh.jpg",
   "https://images.salsify.com/image/upload/s--dzijPu7p--/g2dso9exv50la30jpjat.jpg",
   "https://images.salsify.com/image/upload/s--AEd_7zlQ--/buzzvtityhtni2vzeegb.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-buckingham-16-latex-foam-plush-pillow-top-mattress-set",
  "name": "Serta iComfortPro Buckingham 16\" Latex Foam Plush Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 4869,
  "compareAt": 6349,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "25\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4869,
    "compareAt": 6349
   },
   "Queen": {
    "price": 5419,
    "compareAt": 7049
   },
   "King": {
    "price": 6239,
    "compareAt": 8099
   },
   "California King": {
    "price": 6239,
    "compareAt": 8099
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2hiHuTYV--/crlnjnsg4j6jeg9xruu2.jpg",
   "https://images.salsify.com/image/upload/s--JVGi7A4T--/hax9auhakt95rjhuxqoh.jpg",
   "https://images.salsify.com/image/upload/s--dzijPu7p--/g2dso9exv50la30jpjat.jpg",
   "https://images.salsify.com/image/upload/s--AEd_7zlQ--/buzzvtityhtni2vzeegb.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-canterbury-15-latex-foam-plush-mattress",
  "name": "Serta iComfortPro Canterbury 15\" Latex Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 3599,
  "compareAt": 4699,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3599,
    "compareAt": 4699
   },
   "Queen": {
    "price": 4099,
    "compareAt": 5349
   },
   "King": {
    "price": 4799,
    "compareAt": 6249
   },
   "California King": {
    "price": 4799,
    "compareAt": 6249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
   "https://images.salsify.com/image/upload/s--ZRNO68H0--/tvlxobhm7lwe66ddvgge.jpg",
   "https://images.salsify.com/image/upload/s--4MCNDnZc--/rz3zuwaacbo4avj2ilxs.jpg",
   "https://images.salsify.com/image/upload/s--YR4KB7Dl--/beydrd4qhbinoqirpksv.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-canterbury-15-latex-foam-plush-mattress-low-profile-set",
  "name": "Serta iComfortPro Canterbury 15\" Latex Foam Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3769,
  "compareAt": 4899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3769,
    "compareAt": 4899
   },
   "Queen": {
    "price": 4319,
    "compareAt": 5599
   },
   "King": {
    "price": 5139,
    "compareAt": 6699
   },
   "California King": {
    "price": 5139,
    "compareAt": 6699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
   "https://images.salsify.com/image/upload/s--ZRNO68H0--/tvlxobhm7lwe66ddvgge.jpg",
   "https://images.salsify.com/image/upload/s--4MCNDnZc--/rz3zuwaacbo4avj2ilxs.jpg",
   "https://images.salsify.com/image/upload/s--YR4KB7Dl--/beydrd4qhbinoqirpksv.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-canterbury-15-latex-foam-plush-mattress-set",
  "name": "Serta iComfortPro Canterbury 15\" Latex Foam Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3769,
  "compareAt": 4899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3769,
    "compareAt": 4899
   },
   "Queen": {
    "price": 4319,
    "compareAt": 5599
   },
   "King": {
    "price": 5139,
    "compareAt": 6699
   },
   "California King": {
    "price": 5139,
    "compareAt": 6699
   }
  },
  "image": "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--A3R2qaZ5--/el1wfdfz2gslbvf1p7z7.jpg",
   "https://images.salsify.com/image/upload/s--ZRNO68H0--/tvlxobhm7lwe66ddvgge.jpg",
   "https://images.salsify.com/image/upload/s--4MCNDnZc--/rz3zuwaacbo4avj2ilxs.jpg",
   "https://images.salsify.com/image/upload/s--YR4KB7Dl--/beydrd4qhbinoqirpksv.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-chelsea-12-latex-foam-medium-mattress",
  "name": "Serta iComfortPro Chelsea 12\" Latex Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "12\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
   "https://images.salsify.com/image/upload/s--Az03BEwG--/wevrs6klwhsgoewru4wp.jpg",
   "https://images.salsify.com/image/upload/s--yLIda2AY--/bb5bymjwof0qrwdxelnx.jpg",
   "https://images.salsify.com/image/upload/s--5adBMrIu--/vpyjder5pifh6jtnfg3y.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-chelsea-12-latex-foam-medium-mattress-low-profile-set",
  "name": "Serta iComfortPro Chelsea 12\" Latex Foam Medium Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "18\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
   "https://images.salsify.com/image/upload/s--Az03BEwG--/wevrs6klwhsgoewru4wp.jpg",
   "https://images.salsify.com/image/upload/s--yLIda2AY--/bb5bymjwof0qrwdxelnx.jpg",
   "https://images.salsify.com/image/upload/s--5adBMrIu--/vpyjder5pifh6jtnfg3y.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-chelsea-12-latex-foam-medium-mattress-set",
  "name": "Serta iComfortPro Chelsea 12\" Latex Foam Medium Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "21\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--2WUC25rZ--/ihz8rjp2bu4cqewjg9cv.jpg",
   "https://images.salsify.com/image/upload/s--Az03BEwG--/wevrs6klwhsgoewru4wp.jpg",
   "https://images.salsify.com/image/upload/s--yLIda2AY--/bb5bymjwof0qrwdxelnx.jpg",
   "https://images.salsify.com/image/upload/s--5adBMrIu--/vpyjder5pifh6jtnfg3y.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-dartmouth-15-latex-foam-plush-pillow-top-mattress",
  "name": "Serta iComfortPro Dartmouth 15\" Latex Foam Plush Pillow Top Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2999,
  "compareAt": 3899,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2999,
    "compareAt": 3899
   },
   "Queen": {
    "price": 3499,
    "compareAt": 4549
   },
   "King": {
    "price": 4199,
    "compareAt": 5449
   },
   "California King": {
    "price": 4199,
    "compareAt": 5449
   }
  },
  "image": "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
   "https://images.salsify.com/image/upload/s--JVA84ggx--/vigx8bxvgb9paocf7xyu.jpg",
   "https://images.salsify.com/image/upload/s--qtV1Gzqp--/m7daig5cmamrhufvtxez.jpg",
   "https://images.salsify.com/image/upload/s--re3Ub4YE--/cspje48akxmlgck12fkc.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-dartmouth-15-latex-foam-plush-pillow-top-mattress-low-profile-set",
  "name": "Serta iComfortPro Dartmouth 15\" Latex Foam Plush Pillow Top Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "21\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
   "https://images.salsify.com/image/upload/s--JVA84ggx--/vigx8bxvgb9paocf7xyu.jpg",
   "https://images.salsify.com/image/upload/s--qtV1Gzqp--/m7daig5cmamrhufvtxez.jpg",
   "https://images.salsify.com/image/upload/s--re3Ub4YE--/cspje48akxmlgck12fkc.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-dartmouth-15-latex-foam-plush-pillow-top-mattress-set",
  "name": "Serta iComfortPro Dartmouth 15\" Latex Foam Plush Pillow Top Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 3169,
  "compareAt": 4099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "24\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3169,
    "compareAt": 4099
   },
   "Queen": {
    "price": 3719,
    "compareAt": 4849
   },
   "King": {
    "price": 4539,
    "compareAt": 5899
   },
   "California King": {
    "price": 4539,
    "compareAt": 5899
   }
  },
  "image": "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--hWfzdMEK--/xjcsguxpr7vnh1fvpq5w.jpg",
   "https://images.salsify.com/image/upload/s--JVA84ggx--/vigx8bxvgb9paocf7xyu.jpg",
   "https://images.salsify.com/image/upload/s--qtV1Gzqp--/m7daig5cmamrhufvtxez.jpg",
   "https://images.salsify.com/image/upload/s--re3Ub4YE--/cspje48akxmlgck12fkc.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-firm-mattress",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
   "https://images.salsify.com/image/upload/s--skIHX3uK--/yxrronp1qnkariwl27xn.jpg",
   "https://images.salsify.com/image/upload/s--vO3RLbys--/kyamrywidzyolf338ayh.jpg",
   "https://images.salsify.com/image/upload/s--jQH94xoH--/q0s3nhbmtepmzl2iakdn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-firm-mattress-low-profile-set",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "19\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
   "https://images.salsify.com/image/upload/s--skIHX3uK--/yxrronp1qnkariwl27xn.jpg",
   "https://images.salsify.com/image/upload/s--vO3RLbys--/kyamrywidzyolf338ayh.jpg",
   "https://images.salsify.com/image/upload/s--jQH94xoH--/q0s3nhbmtepmzl2iakdn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-firm-mattress-set",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "22\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fegpk5-a--/ziedf5hm08efqwpknoou.jpg",
   "https://images.salsify.com/image/upload/s--skIHX3uK--/yxrronp1qnkariwl27xn.jpg",
   "https://images.salsify.com/image/upload/s--vO3RLbys--/kyamrywidzyolf338ayh.jpg",
   "https://images.salsify.com/image/upload/s--jQH94xoH--/q0s3nhbmtepmzl2iakdn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-kingston-14-latex-foam-firm-mattress",
  "name": "Serta iComfortPro Kingston 14\" Latex Foam Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2599,
  "compareAt": 3399,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "14\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2599,
    "compareAt": 3399
   },
   "Queen": {
    "price": 3099,
    "compareAt": 4049
   },
   "King": {
    "price": 3799,
    "compareAt": 4949
   },
   "California King": {
    "price": 3799,
    "compareAt": 4949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
   "https://images.salsify.com/image/upload/s--agbt1P_z--/h0bgz5ak8trflrwij3w8.jpg",
   "https://images.salsify.com/image/upload/s--2q6n7t2_--/n0agxht1kfwuftjueadg.jpg",
   "https://images.salsify.com/image/upload/s--YlcwJmDy--/ge40lxoozq15c2ik71dk.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-kingston-14-latex-foam-firm-mattress-low-profile-set",
  "name": "Serta iComfortPro Kingston 14\" Latex Foam Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2769,
  "compareAt": 3599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "20\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2769,
    "compareAt": 3599
   },
   "Queen": {
    "price": 3319,
    "compareAt": 4299
   },
   "King": {
    "price": 4139,
    "compareAt": 5399
   },
   "California King": {
    "price": 4139,
    "compareAt": 5399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
   "https://images.salsify.com/image/upload/s--agbt1P_z--/h0bgz5ak8trflrwij3w8.jpg",
   "https://images.salsify.com/image/upload/s--2q6n7t2_--/n0agxht1kfwuftjueadg.jpg",
   "https://images.salsify.com/image/upload/s--YlcwJmDy--/ge40lxoozq15c2ik71dk.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-kingston-14-latex-foam-firm-mattress-set",
  "name": "Serta iComfortPro Kingston 14\" Latex Foam Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2769,
  "compareAt": 3599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "23\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2769,
    "compareAt": 3599
   },
   "Queen": {
    "price": 3319,
    "compareAt": 4299
   },
   "King": {
    "price": 4139,
    "compareAt": 5399
   },
   "California King": {
    "price": 4139,
    "compareAt": 5399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--NCe67sz8--/u6fqhrzupfrhjjsiyvob.jpg",
   "https://images.salsify.com/image/upload/s--agbt1P_z--/h0bgz5ak8trflrwij3w8.jpg",
   "https://images.salsify.com/image/upload/s--2q6n7t2_--/n0agxht1kfwuftjueadg.jpg",
   "https://images.salsify.com/image/upload/s--YlcwJmDy--/ge40lxoozq15c2ik71dk.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-granby-11-5-latex-foam-extra-firm-mattress",
  "name": "Serta iComfortPro Granby 11.5\" Latex Foam Extra Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1499,
  "compareAt": 1949,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "11.5\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1499,
    "compareAt": 1949
   },
   "Queen": {
    "price": 1999,
    "compareAt": 2599
   },
   "King": {
    "price": 2699,
    "compareAt": 3499
   },
   "California King": {
    "price": 2699,
    "compareAt": 3499
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
   "https://images.salsify.com/image/upload/s--GIVG886M--/hdthiwkrviy67ok2ildp.jpg",
   "https://images.salsify.com/image/upload/s--dAOxDwyU--/ni7u9tetjrsumdrdyzn7.jpg",
   "https://images.salsify.com/image/upload/s--jrUmExZR--/j2egr2m4lzzrh0jdxyfn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-granby-11-5-latex-foam-extra-firm-mattress-low-profile-set",
  "name": "Serta iComfortPro Granby 11.5\" Latex Foam Extra Firm Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "17.5\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
   "https://images.salsify.com/image/upload/s--GIVG886M--/hdthiwkrviy67ok2ildp.jpg",
   "https://images.salsify.com/image/upload/s--dAOxDwyU--/ni7u9tetjrsumdrdyzn7.jpg",
   "https://images.salsify.com/image/upload/s--jrUmExZR--/j2egr2m4lzzrh0jdxyfn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-granby-11-5-latex-foam-extra-firm-mattress-set",
  "name": "Serta iComfortPro Granby 11.5\" Latex Foam Extra Firm Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 1669,
  "compareAt": 2149,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Extra Firm",
  "height": "20.5\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1669,
    "compareAt": 2149
   },
   "Queen": {
    "price": 2219,
    "compareAt": 2899
   },
   "King": {
    "price": 3039,
    "compareAt": 3949
   },
   "California King": {
    "price": 3039,
    "compareAt": 3949
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Wh_-IT5v--/t3y89scowprtanbclej0.jpg",
   "https://images.salsify.com/image/upload/s--GIVG886M--/hdthiwkrviy67ok2ildp.jpg",
   "https://images.salsify.com/image/upload/s--dAOxDwyU--/ni7u9tetjrsumdrdyzn7.jpg",
   "https://images.salsify.com/image/upload/s--jrUmExZR--/j2egr2m4lzzrh0jdxyfn.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-plush-mattress",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1999,
  "compareAt": 2599,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1999,
    "compareAt": 2599
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3199,
    "compareAt": 4149
   },
   "California King": {
    "price": 3199,
    "compareAt": 4149
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
   "https://images.salsify.com/image/upload/s--yuDLKhFe--/xa1yd83r3iyxq87uuax5.jpg",
   "https://images.salsify.com/image/upload/s--MftMwb2m--/as3tuccerlawv0lj7cml.jpg",
   "https://images.salsify.com/image/upload/s--UFkpnBoB--/ctb5lwuuqqtqoj4bb0ex.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-plush-mattress-low-profile-set",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Plush Mattress Low Profile Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "19\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
   "https://images.salsify.com/image/upload/s--yuDLKhFe--/xa1yd83r3iyxq87uuax5.jpg",
   "https://images.salsify.com/image/upload/s--MftMwb2m--/as3tuccerlawv0lj7cml.jpg",
   "https://images.salsify.com/image/upload/s--UFkpnBoB--/ctb5lwuuqqtqoj4bb0ex.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-icomfortpro-ambrose-13-latex-foam-plush-mattress-set",
  "name": "Serta iComfortPro Ambrose 13\" Latex Foam Plush Mattress Set",
  "brand": "serta",
  "category": "mattresses",
  "price": 2169,
  "compareAt": 2799,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "22\"",
  "type": "Latex Foam",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2169,
    "compareAt": 2799
   },
   "Queen": {
    "price": 2719,
    "compareAt": 3549
   },
   "King": {
    "price": 3539,
    "compareAt": 4599
   },
   "California King": {
    "price": 3539,
    "compareAt": 4599
   }
  },
  "image": "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--fI4VjixZ--/jjrxzyx0qs7qknebfivs.jpg",
   "https://images.salsify.com/image/upload/s--yuDLKhFe--/xa1yd83r3iyxq87uuax5.jpg",
   "https://images.salsify.com/image/upload/s--MftMwb2m--/as3tuccerlawv0lj7cml.jpg",
   "https://images.salsify.com/image/upload/s--UFkpnBoB--/ctb5lwuuqqtqoj4bb0ex.jpg"
  ],
  "description": "Serta iComfortPro, our most advanced mattress that features layers of premium latex foam in a 5-zone comfort system. The new iComfortPro features 5 support zones made from natural latex that retains its shape to promote better spinal alignment, while contouring to your body and providing even pressure relief. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-1500-12-memory-foam-luxury-firm-mattress",
  "name": "Serta iSeries NXG 1500 12\" Memory Foam Luxury Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "12\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--Z_pYaYHt--/noddrtumnh50ol00qaci.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--Z_pYaYHt--/noddrtumnh50ol00qaci.jpg",
   "https://images.salsify.com/image/upload/s--cwxYQFsv--/rzwlf43a33unp4uwclzx.jpg",
   "https://images.salsify.com/image/upload/s--f6oNeNZa--/wxmtdofzoh8qdpzkmldy.jpg",
   "https://images.salsify.com/image/upload/s--hLueALgP--/e6aa296e02bac8d2d114dc28c31dc05cf717196e.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We built this firm mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-3500-13-5-memory-foam-medium-mattress",
  "name": "Serta iSeries NXG 3500 13.5\" Memory Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2199,
  "compareAt": 2849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2199,
    "compareAt": 2849
   },
   "Full": {
    "price": 2349,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--ubZHGNHy--/pi7nqktftaae8tt2rzse.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--ubZHGNHy--/pi7nqktftaae8tt2rzse.jpg",
   "https://images.salsify.com/image/upload/s--ZqI4Lmfl--/gfnw1ykapvozijupmgux.jpg",
   "https://images.salsify.com/image/upload/s--Nk3GYi34--/qbja6zouolrnugdbswzx.jpg",
   "https://images.salsify.com/image/upload/s--DNqDTYdp--/b7dwi6jxdnt1wbne9njk.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Medium feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-1500-12-hybrid-firm-mattress",
  "name": "Serta iSeries NXG 1500 12\" Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 2099,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "12\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 2099
   },
   "Full": {
    "price": 1749,
    "compareAt": 2249
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2449
   },
   "King": {
    "price": 2499,
    "compareAt": 3249
   },
   "California King": {
    "price": 2499,
    "compareAt": 3249
   }
  },
  "image": "https://images.salsify.com/image/upload/s--eQ0LmLcx--/f59d6513479021434481e30e013f7fedf09beac7.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--eQ0LmLcx--/f59d6513479021434481e30e013f7fedf09beac7.jpg",
   "https://images.salsify.com/image/upload/s--tALl1WxW--/osyhzxdm907ef18fydwb.jpg",
   "https://images.salsify.com/image/upload/s--PZuay82b--/mfdt8o9prm7llqasfcxb.jpg",
   "https://images.salsify.com/image/upload/s--fQx-cZrP--/d8ff6abf960cef10a3c33c175fc6f050f7c57ac8.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Firm feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-2500-12-5-memory-foam-plush-mattress",
  "name": "Serta iSeries NXG 2500 12.5\" Memory Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "12.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2449
   },
   "Full": {
    "price": 2049,
    "compareAt": 2649
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2849
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--HirVIbsQ--/qeqwzdr90ebf9prj9icy.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--HirVIbsQ--/qeqwzdr90ebf9prj9icy.jpg",
   "https://images.salsify.com/image/upload/s--tm47z_x9--/swwextdkqqwwprosrgj8.jpg",
   "https://images.salsify.com/image/upload/s--gnMDSjfT--/mkyxt2ifmeoatl6c1msv.jpg",
   "https://images.salsify.com/image/upload/s--DoHscaQr--/rufiaka0wmttbfus5aw1.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Plush feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper, more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-3500-13-5-hybrid-firm-mattress",
  "name": "Serta iSeries NXG 3500 13.5\" Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2199,
  "compareAt": 2849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Firm",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2199,
    "compareAt": 2849
   },
   "Full": {
    "price": 2349,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--BSGGq11G--/y811ouq7isfd2al3wifi.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--BSGGq11G--/y811ouq7isfd2al3wifi.jpg",
   "https://images.salsify.com/image/upload/s--5PPbJ1zh--/w47zfmdjtgvqstvw9zwj.jpg",
   "https://images.salsify.com/image/upload/s--6e5uVI6b--/lfsushizqgumxjaspuva.jpg",
   "https://images.salsify.com/image/upload/s--qZIlP5or--/tetneeeccxsemv1je4cl.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Firm feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-2500-12-5-hybrid-medium-mattress",
  "name": "Serta iSeries NXG 2500 12.5\" Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "12.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2449
   },
   "Full": {
    "price": 2049,
    "compareAt": 2649
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2849
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--B6Brf0Rp--/cd27eb4c32123cba0e822c968780fb138a2deefb.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--B6Brf0Rp--/cd27eb4c32123cba0e822c968780fb138a2deefb.jpg",
   "https://images.salsify.com/image/upload/s--29qWAFX2--/s4gqwaadmxvebaqv3j4v.jpg",
   "https://images.salsify.com/image/upload/s--DR_YeiRq--/hhsdygnq3lxdqbopstxe.jpg",
   "https://images.salsify.com/image/upload/s--dp29SUaI--/c437f847fef9620f3c6ecad0f675b30d8a34e6e4.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Medium feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-4500-13-5-memory-foam-ultra-plush-mattress",
  "name": "Serta iSeries NXG 4500 13.5\" Memory Foam Ultra Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2499,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Ultra Plush",
  "height": "13.5\"",
  "type": "Memory Foam",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2499,
    "compareAt": 3249
   },
   "Full": {
    "price": 2649,
    "compareAt": 3449
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3649
   },
   "King": {
    "price": 3399,
    "compareAt": 4399
   },
   "California King": {
    "price": 3399,
    "compareAt": 4399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--wf_Ay9Bk--/bbc6pkn5qk8h6uf0vx3g.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--wf_Ay9Bk--/bbc6pkn5qk8h6uf0vx3g.jpg",
   "https://images.salsify.com/image/upload/s--5nLXvpAD--/eano1gicdyyrwlsmcu4o.jpg",
   "https://images.salsify.com/image/upload/s--L6WQLCWe--/hbwp4wv1ktvnikqwbjdj.jpg",
   "https://images.salsify.com/image/upload/s--z9w_gRZC--/xocncbkynxrydwblwwip.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Ultra Plush feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief, and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-2500-12-5-hybrid-plush-mattress",
  "name": "Serta iSeries NXG 2500 12.5\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2449,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "12.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2449
   },
   "Full": {
    "price": 2049,
    "compareAt": 2649
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2849
   },
   "King": {
    "price": 2799,
    "compareAt": 3649
   },
   "California King": {
    "price": 2799,
    "compareAt": 3649
   }
  },
  "image": "https://images.salsify.com/image/upload/s--oVf-UewS--/43ebb1e80a521bfe194f0e0d24126558d10436e9.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--oVf-UewS--/43ebb1e80a521bfe194f0e0d24126558d10436e9.jpg",
   "https://images.salsify.com/image/upload/s--mHM4ARzc--/b3eh9jw3dowq7lfetikl.jpg",
   "https://images.salsify.com/image/upload/s--f99trLS6--/xj1c0jdrvr4ydw4ipzij.jpg",
   "https://images.salsify.com/image/upload/s--4OWldYNK--/ebqspak7jdscwjsqakwp.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Plush feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-4500-13-5-hybrid-plush-mattress",
  "name": "Serta iSeries NXG 4500 13.5\" Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2499,
  "compareAt": 3249,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Plush",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2499,
    "compareAt": 3249
   },
   "Full": {
    "price": 2649,
    "compareAt": 3449
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3649
   },
   "King": {
    "price": 3399,
    "compareAt": 4399
   },
   "California King": {
    "price": 3399,
    "compareAt": 4399
   }
  },
  "image": "https://images.salsify.com/image/upload/s--qBx86uBs--/n5yjhubvbfpykwio9gho.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--qBx86uBs--/n5yjhubvbfpykwio9gho.jpg",
   "https://images.salsify.com/image/upload/s--PL_p5XWQ--/ota7mxwflyijvapfzk0k.jpg",
   "https://images.salsify.com/image/upload/s--jiNbbKj7--/ufirpoxlkzdfeqkq4nu2.jpg",
   "https://images.salsify.com/image/upload/s--Aqo31_Bs--/fox6gu1lwkfvz6umhv4d.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Plush feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "serta-iseries-nxg-3500-13-5-hybrid-medium-mattress",
  "name": "Serta iSeries NXG 3500 13.5\" Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2199,
  "compareAt": 2849,
  "priceFrom": true,
  "badge": "Save",
  "firmness": "Medium",
  "height": "13.5\"",
  "type": "Hybrid",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2199,
    "compareAt": 2849
   },
   "Full": {
    "price": 2349,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2499,
    "compareAt": 3249
   },
   "King": {
    "price": 3099,
    "compareAt": 4049
   },
   "California King": {
    "price": 3099,
    "compareAt": 4049
   }
  },
  "image": "https://images.salsify.com/image/upload/s--VQUMLpMz--/pxxwjvkngtzrlc5pbqvg.jpg",
  "gallery": [
   "https://images.salsify.com/image/upload/s--VQUMLpMz--/pxxwjvkngtzrlc5pbqvg.jpg",
   "https://images.salsify.com/image/upload/s--x6FXcXOT--/lwfgo9dgrolrov166all.jpg",
   "https://images.salsify.com/image/upload/s--1arjzFfv--/ubzpj7hllzixgydmecv9.jpg",
   "https://images.salsify.com/image/upload/s--sDSCOLJy--/aebcc596a7ffeac297758fa97c1389b6bb1f8b63.jpg"
  ],
  "description": "We've evolved the Serta iSeries NXG to be the next generation of comfort. We've built this Medium feel mattress with a series of benefits for the sleep you want. Experience immediate cooling, instant pressure relief and ideal support for a deeper , more restful sleep at a price that makes sense. Available at MattressTown in all sizes with local delivery, professional set-up and old-mattress removal."
 }
];
